var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModernMinimalQr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2630_28353)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0996 0H1.09961V40H41.0996V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2630_28353)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 41,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0996 0H1.09961V40H41.0996V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0996 0H1.09961V40H41.0996V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 6,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09961 4V5.6C3.09961 6.13043 3.31033 6.63914 3.6854 7.01421C4.06047 7.38929 4.56918 7.6 5.09961 7.6H6.69961C7.23005 7.6 7.73876 7.38929 8.11383 7.01421C8.4889 6.63914 8.69961 6.13043 8.69961 5.6V4C8.69961 3.46957 8.4889 2.96086 8.11383 2.58579C7.73876 2.21071 7.23005 2 6.69961 2H5.09961C4.56918 2 4.06047 2.21071 3.6854 2.58579C3.31033 2.96086 3.09961 3.46957 3.09961 4ZM5.09961 2.8H6.69961C7.01787 2.8 7.3231 2.92643 7.54814 3.15147C7.77319 3.37652 7.89961 3.68174 7.89961 4V5.6C7.89961 5.91826 7.77319 6.22348 7.54814 6.44853C7.3231 6.67357 7.01787 6.8 6.69961 6.8H5.09961C4.78135 6.8 4.47613 6.67357 4.25109 6.44853C4.02604 6.22348 3.89961 5.91826 3.89961 5.6V4C3.89961 3.68174 4.02604 3.37652 4.25109 3.15147C4.47613 2.92643 4.78135 2.8 5.09961 2.8Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69961 2H3.09961V7.6H8.69961V2Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 4,
    height: 3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89971 6.0001C6.56245 6.0001 7.09971 5.46284 7.09971 4.8001C7.09971 4.13736 6.56245 3.6001 5.89971 3.6001C5.23697 3.6001 4.69971 4.13736 4.69971 4.8001C4.69971 5.46284 5.23697 6.0001 5.89971 6.0001Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09971 3.6001H4.69971V6.0001H7.09971V3.6001Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 2,
    width: 7,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0995 2H35.4995C34.9691 2 34.4604 2.21071 34.0853 2.58579C33.7102 2.96086 33.4995 3.46957 33.4995 4V5.6C33.4995 6.13043 33.7102 6.63914 34.0853 7.01421C34.4604 7.38929 34.9691 7.6 35.4995 7.6H37.0995C37.6299 7.6 38.1386 7.38929 38.5137 7.01421C38.8888 6.63914 39.0995 6.13043 39.0995 5.6V4C39.0995 3.46957 38.8888 2.96086 38.5137 2.58579C38.1386 2.21071 37.6299 2 37.0995 2ZM38.2995 4V5.6C38.2995 5.91826 38.1731 6.22348 37.948 6.44853C37.723 6.67357 37.4178 6.8 37.0995 6.8H35.4995C35.1812 6.8 34.876 6.67357 34.651 6.44853C34.4259 6.22348 34.2995 5.91826 34.2995 5.6V4C34.2995 3.68174 34.4259 3.37651 34.651 3.15147C34.876 2.92643 35.1812 2.8 35.4995 2.8H37.0995C37.4178 2.8 37.723 2.92643 37.948 3.15147C38.1731 3.37651 38.2995 3.68174 38.2995 4Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0995 2H33.4995V7.6H39.0995V2Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 3,
    width: 3,
    height: 3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 4.8001C35.0996 5.46284 35.6369 6.0001 36.2996 6.0001C36.9623 6.0001 37.4996 5.46284 37.4996 4.8001C37.4996 4.13736 36.9623 3.6001 36.2996 3.6001C35.6369 3.6001 35.0996 4.13736 35.0996 4.8001Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4996 3.6001H35.0996V6.0001H37.4996V3.6001Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 32,
    width: 6,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09961 37.9999H6.69961C7.23005 37.9999 7.73875 37.7892 8.11383 37.4141C8.4889 37.039 8.69961 36.5303 8.69961 35.9999V34.3999C8.69961 33.8695 8.4889 33.3608 8.11383 32.9857C7.73875 32.6106 7.23005 32.3999 6.69961 32.3999H5.09961C4.56918 32.3999 4.06047 32.6106 3.6854 32.9857C3.31033 33.3608 3.09961 33.8695 3.09961 34.3999V35.9999C3.09961 36.5303 3.31033 37.039 3.6854 37.4141C4.06047 37.7892 4.56918 37.9999 5.09961 37.9999ZM3.89961 35.9999V34.3999C3.89961 34.0816 4.02604 33.7764 4.25109 33.5514C4.47613 33.3263 4.78135 33.1999 5.09961 33.1999H6.69961C7.01787 33.1999 7.3231 33.3263 7.54814 33.5514C7.77318 33.7764 7.89961 34.0816 7.89961 34.3999V35.9999C7.89961 36.3182 7.77318 36.6234 7.54814 36.8484C7.3231 37.0735 7.01787 37.1999 6.69961 37.1999H5.09961C4.78135 37.1999 4.47613 37.0735 4.25109 36.8484C4.02604 36.6234 3.89961 36.3182 3.89961 35.9999Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69961 32.3999H3.09961V37.9999H8.69961V32.3999Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 34,
    width: 4,
    height: 3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09971 35.2C7.09971 34.5373 6.56245 34 5.89971 34C5.23697 34 4.69971 34.5373 4.69971 35.2C4.69971 35.8627 5.23697 36.4 5.89971 36.4C6.56245 36.4 7.09971 35.8627 7.09971 35.2Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.09971 34H4.69971V36.4H7.09971V34Z",
    fill: "#333333"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3663 17.7334H18.833V22.2667H23.3663V17.7334Z",
    fill: "url(#pattern0_2630_28353)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2630_28353",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 37,
    height: 36
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 2.8V2H11.4996C11.3935 2 11.2918 2.04215 11.2168 2.11716C11.1418 2.19218 11.0996 2.29392 11.0996 2.4C11.0996 2.50609 11.1418 2.60783 11.2168 2.68285C11.2918 2.75786 11.3935 2.8 11.4996 2.8",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 2V2.8H12.6994V2.4C12.6994 2.29391 12.6573 2.19217 12.5823 2.11716C12.5072 2.04214 12.4055 2 12.2994 2",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 2.8H15.0993V2H14.6993C14.5932 2 14.4915 2.04215 14.4165 2.11716C14.3415 2.19218 14.2993 2.29392 14.2993 2.4",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 2V2.8H15.4996C15.6057 2.8 15.7074 2.75786 15.7824 2.68284C15.8575 2.60783 15.8996 2.50609 15.8996 2.4C15.8996 2.29391 15.8575 2.19217 15.7824 2.11716C15.7074 2.04214 15.6057 2 15.4996 2",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6993 2.8C18.9202 2.8 19.0993 2.62091 19.0993 2.4C19.0993 2.17909 18.9202 2 18.6993 2C18.4784 2 18.2993 2.17909 18.2993 2.4C18.2993 2.62091 18.4784 2.8 18.6993 2.8Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 2.8H21.4997V2H21.0997C20.9936 2 20.8919 2.04215 20.8169 2.11716C20.7418 2.19218 20.6997 2.29392 20.6997 2.4",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 2V2.8H22.2995V2.4C22.2995 2.29391 22.2574 2.19217 22.1824 2.11716C22.1073 2.04214 22.0056 2 21.8995 2",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 2.8V2H23.4996C23.3935 2 23.2918 2.04215 23.2168 2.11716C23.1418 2.19218 23.0996 2.29392 23.0996 2.4C23.0996 2.50609 23.1418 2.60783 23.2168 2.68285C23.2918 2.75786 23.3935 2.8 23.4996 2.8",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 2V2.8H24.2994C24.4055 2.8 24.5072 2.75786 24.5823 2.68284C24.6573 2.60783 24.6994 2.50609 24.6994 2.4C24.6994 2.29391 24.6573 2.19217 24.5823 2.11716C24.5072 2.04214 24.4055 2 24.2994 2",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 2.8H27.0993V2H26.6993C26.5932 2 26.4915 2.04215 26.4165 2.11716C26.3415 2.19218 26.2993 2.29392 26.2993 2.4",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 2V2.8H27.4996C27.6057 2.8 27.7074 2.75786 27.7824 2.68284C27.8575 2.60783 27.8996 2.50609 27.8996 2.4C27.8996 2.29391 27.8575 2.19217 27.7824 2.11716C27.7074 2.04214 27.6057 2 27.4996 2",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 2.8H29.4997V2.4C29.4997 2.29392 29.4576 2.19218 29.3825 2.11716C29.3075 2.04215 29.2058 2 29.0997 2C28.9936 2 28.8919 2.04215 28.8169 2.11716C28.7418 2.19218 28.6997 2.29392 28.6997 2.4",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2994 2.8C32.5203 2.8 32.6994 2.62091 32.6994 2.4C32.6994 2.17909 32.5203 2 32.2994 2C32.0785 2 31.8994 2.17909 31.8994 2.4C31.8994 2.62091 32.0785 2.8 32.2994 2.8Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 3.60029V2.80029H11.8999V3.20029C11.8999 3.30637 11.942 3.40812 12.0171 3.48313C12.0921 3.55814 12.1938 3.60029 12.2999 3.60029",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 2.7998V3.5998H13.4997V3.1998C13.4997 3.09372 13.4576 2.99198 13.3825 2.91696C13.3075 2.84195 13.2058 2.7998 13.0997 2.7998",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 2.7998H14.2998V3.1998C14.2998 3.30589 14.3419 3.40763 14.417 3.48265C14.492 3.55766 14.5937 3.5998 14.6998 3.5998C14.8059 3.5998 14.9076 3.55766 14.9826 3.48265C15.0577 3.40763 15.0998 3.30589 15.0998 3.1998",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 3.60029H16.6994V3.20029C16.6994 3.0942 16.6573 2.99246 16.5823 2.91744C16.5072 2.84243 16.4055 2.80029 16.2994 2.80029C16.1933 2.80029 16.0916 2.84243 16.0166 2.91744C15.9416 2.99246 15.8994 3.0942 15.8994 3.20029",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 2.7998H20.6997V3.5998H21.4997V2.7998Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 2.7998H21.4995V3.5998H22.2995V2.7998Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0997 3.5998C25.3206 3.5998 25.4997 3.42072 25.4997 3.1998C25.4997 2.97889 25.3206 2.7998 25.0997 2.7998C24.8788 2.7998 24.6997 2.97889 24.6997 3.1998C24.6997 3.42072 24.8788 3.5998 25.0997 3.5998Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 2.7998H26.2993V3.5998H27.0993V2.7998Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 3.60029H28.6994V2.80029H28.2994C28.1933 2.80029 28.0916 2.84243 28.0166 2.91744C27.9416 2.99246 27.8994 3.0942 27.8994 3.20029",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 2.7998H28.6997V3.5998H29.0997C29.2058 3.5998 29.3075 3.55766 29.3825 3.48265C29.4576 3.40763 29.4997 3.30589 29.4997 3.1998",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 3.60029H31.8996V3.20029C31.8996 3.0942 31.8575 2.99246 31.7824 2.91744C31.7074 2.84243 31.6057 2.80029 31.4996 2.80029C31.3935 2.80029 31.2918 2.84243 31.2168 2.91744C31.1417 2.99246 31.0996 3.0942 31.0996 3.20029",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 4.4001H10.2995V4.0001C10.2995 3.89402 10.2574 3.79227 10.1824 3.71726C10.1073 3.64224 10.0056 3.6001 9.89951 3.6001C9.79342 3.6001 9.69168 3.64224 9.61666 3.71726C9.54165 3.79227 9.49951 3.89402 9.49951 4.0001",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4996 4.4001C11.7205 4.4001 11.8996 4.22101 11.8996 4.0001C11.8996 3.77918 11.7205 3.6001 11.4996 3.6001C11.2787 3.6001 11.0996 3.77918 11.0996 4.0001C11.0996 4.22101 11.2787 4.4001 11.4996 4.4001Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 4.4001V3.6001H12.6997V4.0001C12.6997 4.10619 12.7418 4.20793 12.8169 4.28295C12.8919 4.35796 12.9936 4.4001 13.0997 4.4001",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 3.6001V4.4001H14.2995V4.0001C14.2995 3.89401 14.2574 3.79227 14.1824 3.71725C14.1073 3.64224 14.0056 3.6001 13.8995 3.6001",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 4.4001H15.8996V3.6001H15.4996C15.3935 3.6001 15.2918 3.64224 15.2168 3.71726C15.1417 3.79227 15.0996 3.89402 15.0996 4.0001",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 3.6001H15.8999V4.4001H16.2999C16.406 4.4001 16.5077 4.35796 16.5827 4.28294C16.6578 4.20793 16.6999 4.10618 16.6999 4.0001",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6993 4.4001C18.9202 4.4001 19.0993 4.22101 19.0993 4.0001C19.0993 3.77918 18.9202 3.6001 18.6993 3.6001C18.4784 3.6001 18.2993 3.77918 18.2993 4.0001C18.2993 4.22101 18.4784 4.4001 18.6993 4.4001Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8994 4.4001H20.6994V3.6001H20.2994C20.1933 3.6001 20.0916 3.64224 20.0166 3.71726C19.9416 3.79227 19.8994 3.89402 19.8994 4.0001",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 3.6001H20.6997V4.4001H21.4997V3.6001Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 3.6001H21.4995V4.4001H22.2995V3.6001Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2993 3.6001V4.4001H23.0993V4.0001C23.0993 3.89401 23.0572 3.79227 22.9822 3.71725C22.9071 3.64224 22.8054 3.6001 22.6993 3.6001",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 4.4001H26.2995V3.6001H25.8995C25.7934 3.6001 25.6917 3.64224 25.6167 3.71726C25.5416 3.79227 25.4995 3.89402 25.4995 4.0001",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 3.6001H26.2993V4.4001H27.0993V3.6001Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 3.6001H27.0996V4.4001H27.8996V3.6001Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 3.6001H27.8994V4.4001H28.6994V3.6001Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 3.6001H31.0996V4.4001H31.8996V3.6001Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 5.20039V4.40039H9.49951V4.80039C9.49951 4.90647 9.54165 5.00821 9.61667 5.08323C9.69168 5.15824 9.79343 5.20039 9.89951 5.20039",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 4.3999V5.1999H10.6993C10.8054 5.1999 10.9071 5.15776 10.9822 5.08274C11.0572 5.00773 11.0993 4.90599 11.0993 4.7999C11.0993 4.69382 11.0572 4.59207 10.9822 4.51706C10.9071 4.44205 10.8054 4.3999 10.6993 4.3999",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 5.20039H12.6994V4.80039C12.6994 4.6943 12.6573 4.59256 12.5823 4.51754C12.5072 4.44253 12.4055 4.40039 12.2994 4.40039C12.1933 4.40039 12.0916 4.44253 12.0166 4.51754C11.9416 4.59256 11.8994 4.6943 11.8994 4.80039",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 4.3999H13.4995V4.7999C13.4995 4.90599 13.5417 5.00773 13.6167 5.08275C13.6917 5.15776 13.7934 5.1999 13.8995 5.1999C14.0056 5.1999 14.1073 5.15776 14.1824 5.08275C14.2574 5.00773 14.2995 4.90599 14.2995 4.7999",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 4.3999H15.0996V4.7999C15.0996 4.90599 15.1418 5.00773 15.2168 5.08275C15.2918 5.15776 15.3935 5.1999 15.4996 5.1999C15.6057 5.1999 15.7074 5.15776 15.7825 5.08275C15.8575 5.00773 15.8996 4.90599 15.8996 4.7999",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 4.3999H19.8994V5.1999H20.6994V4.3999Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 4.3999H21.4995V5.1999H22.2995V4.3999Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 4.3999H22.2993V5.1999H23.0993V4.3999Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 4.3999H23.0996V5.1999H23.8996V4.3999Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 4.3999V5.1999H24.6994V4.7999C24.6994 4.69382 24.6573 4.59207 24.5823 4.51706C24.5072 4.44205 24.4055 4.3999 24.2994 4.3999",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 5.20039V4.40039H25.4995V4.80039C25.4995 4.90647 25.5417 5.00821 25.6167 5.08323C25.6917 5.15824 25.7934 5.20039 25.8995 5.20039",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 4.3999H26.2993V5.1999H27.0993V4.3999Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 4.3999H27.0996V5.1999H27.8996V4.3999Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 4.3999H27.8999V5.1999H28.2999C28.406 5.1999 28.5077 5.15776 28.5827 5.08275C28.6578 5.00773 28.6999 4.90599 28.6999 4.7999",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 5.20039H30.2995V4.80039C30.2995 4.6943 30.2574 4.59256 30.1823 4.51754C30.1073 4.44253 30.0056 4.40039 29.8995 4.40039C29.7934 4.40039 29.6917 4.44253 29.6167 4.51754C29.5416 4.59256 29.4995 4.6943 29.4995 4.80039",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 4.3999H31.0996V5.1999H31.8996V4.3999Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 4.3999V5.1999H32.6994V4.7999C32.6994 4.69382 32.6573 4.59207 32.5823 4.51706C32.5072 4.44205 32.4055 4.3999 32.2994 4.3999",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 6.0002V5.2002H11.4996C11.3935 5.2002 11.2918 5.24234 11.2168 5.31736C11.1418 5.39237 11.0996 5.49411 11.0996 5.6002C11.0996 5.70629 11.1418 5.80803 11.2168 5.88304C11.2918 5.95806 11.3935 6.0002 11.4996 6.0002",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 5.2002H11.8994V6.0002H12.6994V5.2002Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 5.2002V6.0002H13.4997V5.6002C13.4997 5.49411 13.4576 5.39237 13.3825 5.31735C13.3075 5.24234 13.2058 5.2002 13.0997 5.2002",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 6.0002H15.0993V5.6002C15.0993 5.49411 15.0572 5.39237 14.9822 5.31736C14.9071 5.24234 14.8054 5.2002 14.6993 5.2002C14.5932 5.2002 14.4915 5.24234 14.4165 5.31736C14.3415 5.39237 14.2993 5.49411 14.2993 5.6002",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2994 6.0002C16.5203 6.0002 16.6994 5.82111 16.6994 5.6002C16.6994 5.37928 16.5203 5.2002 16.2994 5.2002C16.0785 5.2002 15.8994 5.37928 15.8994 5.6002C15.8994 5.82111 16.0785 6.0002 16.2994 6.0002Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 6.0002V5.2002H17.8995C17.7934 5.2002 17.6917 5.24234 17.6167 5.31736C17.5417 5.39237 17.4995 5.49411 17.4995 5.6002C17.4995 5.70629 17.5417 5.80803 17.6167 5.88304C17.6917 5.95806 17.7934 6.0002 17.8995 6.0002",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 5.2002H18.2993V6.0002H19.0993V5.2002Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 5.2002H19.0996V6.0002H19.8996V5.2002Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 5.2002H19.8994V6.0002H20.6994V5.2002Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 5.2002H20.6997V6.0002H21.4997V5.2002Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 5.2002H21.4995V6.0002H22.2995V5.2002Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 5.2002H22.2993V6.0002H23.0993V5.2002Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 6.0002V5.2002H23.8999V5.6002C23.8999 5.70629 23.942 5.80803 24.0171 5.88304C24.0921 5.95806 24.1938 6.0002 24.2999 6.0002",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 5.2002V6.0002H25.0997C25.2058 6.0002 25.3075 5.95805 25.3825 5.88304C25.4576 5.80802 25.4997 5.70628 25.4997 5.6002C25.4997 5.49411 25.4576 5.39237 25.3825 5.31735C25.3075 5.24234 25.2058 5.2002 25.0997 5.2002",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 6.0002V5.2002H26.2998V5.6002C26.2998 5.70629 26.3419 5.80803 26.417 5.88304C26.492 5.95806 26.5937 6.0002 26.6998 6.0002",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 5.2002H27.0996V6.0002H27.4996C27.6057 6.0002 27.7074 5.95805 27.7825 5.88304C27.8575 5.80802 27.8996 5.70628 27.8996 5.6002",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 6.0002V5.2002H29.4995V5.6002C29.4995 5.70629 29.5417 5.80803 29.6167 5.88304C29.6917 5.95806 29.7934 6.0002 29.8995 6.0002",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 5.2002H30.2993V6.0002H31.0993V5.2002Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 5.2002H31.0996V6.0002H31.8996V5.2002Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 5.2002H31.8999V6.0002H32.2999C32.406 6.0002 32.5077 5.95805 32.5827 5.88304C32.6578 5.80802 32.6999 5.70628 32.6999 5.6002",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 6H12.6997V6.8H13.4997V6Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 6H13.4995V6.8H14.2995V6Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 6H14.2993V6.8H15.0993V6Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0997 6.8C17.3206 6.8 17.4997 6.62091 17.4997 6.4C17.4997 6.17909 17.3206 6 17.0997 6C16.8788 6 16.6997 6.17909 16.6997 6.4C16.6997 6.62091 16.8788 6.8 17.0997 6.8Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 6H19.0996V6.8H19.8996V6Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 6H22.2993V6.8H23.0993V6Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 6V6.8H23.4996C23.6057 6.8 23.7074 6.75786 23.7824 6.68284C23.8575 6.60783 23.8996 6.50609 23.8996 6.4C23.8996 6.29391 23.8575 6.19217 23.7824 6.11716C23.7074 6.04214 23.6057 6 23.4996 6",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 6.8H26.2995V6.4C26.2995 6.29392 26.2574 6.19218 26.1823 6.11716C26.1073 6.04215 26.0056 6 25.8995 6C25.7934 6 25.6917 6.04215 25.6167 6.11716C25.5416 6.19218 25.4995 6.29392 25.4995 6.4",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 6.8V6H28.2999C28.1938 6 28.0921 6.04215 28.0171 6.11716C27.942 6.19218 27.8999 6.29392 27.8999 6.4C27.8999 6.50609 27.942 6.60783 28.0171 6.68285C28.0921 6.75786 28.1938 6.8 28.2999 6.8",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 6V6.8H29.4997V6.4C29.4997 6.29391 29.4576 6.19217 29.3825 6.11716C29.3075 6.04214 29.2058 6 29.0997 6",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89951 7.5998C10.1204 7.5998 10.2995 7.42072 10.2995 7.1998C10.2995 6.97889 10.1204 6.7998 9.89951 6.7998C9.67859 6.7998 9.49951 6.97889 9.49951 7.1998C9.49951 7.42072 9.67859 7.5998 9.89951 7.5998Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 7.60029H11.8996V7.20029C11.8996 7.0942 11.8575 6.99246 11.7824 6.91744C11.7074 6.84243 11.6057 6.80029 11.4996 6.80029C11.3935 6.80029 11.2918 6.84243 11.2168 6.91744C11.1417 6.99246 11.0996 7.0942 11.0996 7.20029",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 6.7998H12.6997V7.5998H13.4997V6.7998Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 6.7998H14.2993V7.5998H15.0993V6.7998Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2994 7.5998C16.5203 7.5998 16.6994 7.42072 16.6994 7.1998C16.6994 6.97889 16.5203 6.7998 16.2994 6.7998C16.0785 6.7998 15.8994 6.97889 15.8994 7.1998C15.8994 7.42072 16.0785 7.5998 16.2994 7.5998Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 7.60029H18.2995V7.20029C18.2995 7.0942 18.2574 6.99246 18.1823 6.91744C18.1073 6.84243 18.0056 6.80029 17.8995 6.80029C17.7934 6.80029 17.6917 6.84243 17.6167 6.91744C17.5416 6.99246 17.4995 7.0942 17.4995 7.20029",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 6.7998H19.0996V7.5998H19.8996V6.7998Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0997 7.5998C21.3206 7.5998 21.4997 7.42072 21.4997 7.1998C21.4997 6.97889 21.3206 6.7998 21.0997 6.7998C20.8788 6.7998 20.6997 6.97889 20.6997 7.1998C20.6997 7.42072 20.8788 7.5998 21.0997 7.5998Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 6.7998H22.2993V7.5998H23.0993V6.7998Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 7.60029H24.6994V7.20029C24.6994 7.0942 24.6573 6.99246 24.5823 6.91744C24.5072 6.84243 24.4055 6.80029 24.2994 6.80029C24.1933 6.80029 24.0916 6.84243 24.0166 6.91744C23.9416 6.99246 23.8994 7.0942 23.8994 7.20029",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 6.7998H25.4995V7.1998C25.4995 7.30589 25.5417 7.40763 25.6167 7.48265C25.6917 7.55766 25.7934 7.5998 25.8995 7.5998C26.0056 7.5998 26.1073 7.55766 26.1824 7.48265C26.2574 7.40763 26.2995 7.30589 26.2995 7.1998",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 7.60029H27.8996V7.20029C27.8996 7.0942 27.8575 6.99246 27.7824 6.91744C27.7074 6.84243 27.6057 6.80029 27.4996 6.80029C27.3935 6.80029 27.2918 6.84243 27.2168 6.91744C27.1417 6.99246 27.0996 7.0942 27.0996 7.20029",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 6.7998H28.6997V7.5998H29.4997V6.7998Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 7.60029H31.0993V7.20029C31.0993 7.0942 31.0572 6.99246 30.9822 6.91744C30.9071 6.84243 30.8054 6.80029 30.6993 6.80029C30.5932 6.80029 30.4915 6.84243 30.4165 6.91744C30.3415 6.99246 30.2993 7.0942 30.2993 7.20029",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2994 7.5998C32.5203 7.5998 32.6994 7.42072 32.6994 7.1998C32.6994 6.97889 32.5203 6.7998 32.2994 6.7998C32.0785 6.7998 31.8994 6.97889 31.8994 7.1998C31.8994 7.42072 32.0785 7.5998 32.2994 7.5998Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 8.4001V7.6001H11.0996V8.0001C11.0996 8.10619 11.1418 8.20793 11.2168 8.28294C11.2918 8.35796 11.3935 8.4001 11.4996 8.4001",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 7.6001H11.8994V8.4001H12.6994V7.6001Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 7.6001H12.6997V8.4001H13.0997C13.2058 8.4001 13.3075 8.35796 13.3825 8.28294C13.4576 8.20793 13.4997 8.10618 13.4997 8.0001",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 7.6001H14.2998V8.0001C14.2998 8.10618 14.3419 8.20793 14.417 8.28294C14.492 8.35796 14.5937 8.4001 14.6998 8.4001C14.8059 8.4001 14.9076 8.35796 14.9826 8.28294C15.0577 8.20793 15.0998 8.10618 15.0998 8.0001",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 8.4001V7.6001H17.0997C16.9936 7.6001 16.8919 7.64225 16.8169 7.71726C16.7418 7.79227 16.6997 7.89402 16.6997 8.0001C16.6997 8.10619 16.7418 8.20793 16.8169 8.28294C16.8919 8.35796 16.9936 8.4001 17.0997 8.4001",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 7.6001H17.4995V8.4001H17.8995C18.0056 8.4001 18.1073 8.35796 18.1824 8.28294C18.2574 8.20793 18.2995 8.10618 18.2995 8.0001",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 7.6001H19.0996V8.4001H19.8996V7.6001Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 7.6001H22.2993V8.4001H23.0993V7.6001Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 7.6001H23.8999V8.0001C23.8999 8.10618 23.942 8.20793 24.0171 8.28294C24.0921 8.35796 24.1938 8.4001 24.2999 8.4001C24.406 8.4001 24.5077 8.35796 24.5827 8.28294C24.6578 8.20793 24.6999 8.10618 24.6999 8.0001",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 8.4001V7.6001H26.6998C26.5937 7.6001 26.492 7.64225 26.417 7.71726C26.3419 7.79227 26.2998 7.89402 26.2998 8.0001C26.2998 8.10619 26.3419 8.20793 26.417 8.28294C26.492 8.35796 26.5937 8.4001 26.6998 8.4001",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 7.6001H27.0996V8.4001H27.8996V7.6001Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 7.6001H28.6997V8.0001C28.6997 8.10618 28.7418 8.20793 28.8169 8.28294C28.8919 8.35796 28.9936 8.4001 29.0997 8.4001C29.2058 8.4001 29.3075 8.35796 29.3825 8.28294C29.4576 8.20793 29.4997 8.10618 29.4997 8.0001",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 7.6001H30.2993V8.4001H31.0993V7.6001Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 7.6001V8.4001H31.8996V8.0001C31.8996 7.89401 31.8575 7.79227 31.7824 7.71726C31.7074 7.64224 31.6057 7.6001 31.4996 7.6001",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 9.20039V8.40039H5.89951C5.79343 8.40039 5.69168 8.44253 5.61667 8.51754C5.54165 8.59256 5.49951 8.6943 5.49951 8.80039C5.49951 8.90647 5.54165 9.00821 5.61667 9.08323C5.69168 9.15824 5.79343 9.20039 5.89951 9.20039",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29932 8.3999V9.1999H7.09932V8.7999C7.09932 8.69382 7.05718 8.59207 6.98216 8.51706C6.90715 8.44205 6.80541 8.3999 6.69932 8.3999",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 9.20039V8.40039H8.2999C8.19382 8.40039 8.09207 8.44253 8.01706 8.51754C7.94205 8.59256 7.8999 8.6943 7.8999 8.80039C7.8999 8.90647 7.94205 9.00821 8.01706 9.08323C8.09207 9.15824 8.19382 9.20039 8.2999 9.20039",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 8.3999V9.1999H9.09971C9.2058 9.1999 9.30754 9.15776 9.38255 9.08275C9.45757 9.00773 9.49971 8.90599 9.49971 8.7999C9.49971 8.69382 9.45757 8.59207 9.38255 8.51706C9.30754 8.44205 9.2058 8.3999 9.09971 8.3999",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 9.20039V8.40039H18.6998C18.5937 8.40039 18.492 8.44253 18.417 8.51754C18.3419 8.59256 18.2998 8.6943 18.2998 8.80039C18.2998 8.90647 18.3419 9.00821 18.417 9.08323C18.492 9.15824 18.5937 9.20039 18.6998 9.20039",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 8.3999H19.0996V9.1999H19.8996V8.3999Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 8.3999H19.8994V9.1999H20.6994V8.3999Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 8.3999H20.6997V9.1999H21.4997V8.3999Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 8.3999H21.4995V9.1999H22.2995V8.3999Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 8.3999H22.2993V9.1999H23.0993V8.3999Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 8.3999V9.1999H23.8996V8.7999C23.8996 8.69382 23.8575 8.59207 23.7824 8.51706C23.7074 8.44205 23.6057 8.3999 23.4996 8.3999",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0997 9.1999C25.3206 9.1999 25.4997 9.02082 25.4997 8.7999C25.4997 8.57899 25.3206 8.3999 25.0997 8.3999C24.8788 8.3999 24.6997 8.57899 24.6997 8.7999C24.6997 9.02082 24.8788 9.1999 25.0997 9.1999Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 8.3999H27.0996V9.1999H27.8996V8.3999Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 8.3999V9.1999H28.6994V8.7999C28.6994 8.69382 28.6573 8.59207 28.5823 8.51706C28.5072 8.44205 28.4055 8.3999 28.2994 8.3999",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 8.3999H30.2993V9.1999H31.0993V8.3999Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 8.3999H31.0996V9.1999H31.8996V8.3999Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 8.3999V9.1999H32.6994V8.7999C32.6994 8.69382 32.6573 8.59207 32.5823 8.51706C32.5072 8.44205 32.4055 8.3999 32.2994 8.3999",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 9.20039H36.6994V8.40039H36.2994C36.1933 8.40039 36.0916 8.44253 36.0166 8.51754C35.9416 8.59256 35.8994 8.6943 35.8994 8.80039",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 8.3999V9.1999H37.0997C37.2058 9.1999 37.3075 9.15776 37.3825 9.08275C37.4576 9.00773 37.4997 8.90599 37.4997 8.7999C37.4997 8.69382 37.4576 8.59207 37.3825 8.51706C37.3075 8.44205 37.2058 8.3999 37.0997 8.3999",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 10.0002V9.2002H3.49961C3.39352 9.2002 3.29178 9.24234 3.21677 9.31736C3.14175 9.39237 3.09961 9.49411 3.09961 9.6002C3.09961 9.70629 3.14175 9.80803 3.21677 9.88304C3.29178 9.95806 3.39352 10.0002 3.49961 10.0002",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 9.2002V10.0002H4.29941C4.4055 10.0002 4.50724 9.95805 4.58225 9.88304C4.65727 9.80802 4.69941 9.70627 4.69941 9.60019C4.69941 9.4941 4.65727 9.39237 4.58225 9.31735C4.50724 9.24234 4.4055 9.2002 4.29941 9.2002",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 9.2002H6.2998V9.60019C6.2998 9.70627 6.34195 9.80802 6.41696 9.88304C6.49198 9.95805 6.59372 10.0002 6.6998 10.0002C6.80589 10.0002 6.90763 9.95805 6.98265 9.88304C7.05766 9.80802 7.0998 9.70627 7.0998 9.60019",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 10.0002H11.8996V9.2002H11.4996C11.3935 9.2002 11.2918 9.24234 11.2168 9.31736C11.1417 9.39237 11.0996 9.49411 11.0996 9.6002",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 9.2002H11.8994V10.0002H12.6994V9.2002Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 9.2002V10.0002H13.4997V9.60019C13.4997 9.4941 13.4576 9.39237 13.3825 9.31735C13.3075 9.24234 13.2058 9.2002 13.0997 9.2002",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 10.0002H15.8996V9.2002H15.4996C15.3935 9.2002 15.2918 9.24234 15.2168 9.31736C15.1417 9.39237 15.0996 9.49411 15.0996 9.6002",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 9.2002V10.0002H16.2994C16.4055 10.0002 16.5072 9.95805 16.5823 9.88304C16.6573 9.80802 16.6994 9.70627 16.6994 9.60019C16.6994 9.4941 16.6573 9.39237 16.5823 9.31735C16.5072 9.24234 16.4055 9.2002 16.2994 9.2002",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 9.2002H19.8999V9.60019C19.8999 9.70627 19.942 9.80802 20.0171 9.88304C20.0921 9.95805 20.1938 10.0002 20.2999 10.0002C20.406 10.0002 20.5077 9.95805 20.5827 9.88304C20.6578 9.80802 20.6999 9.70627 20.6999 9.60019",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 9.2002H23.0996V10.0002H23.8996V9.2002Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 9.2002V10.0002H24.6994V9.60019C24.6994 9.4941 24.6573 9.39237 24.5823 9.31735C24.5072 9.24234 24.4055 9.2002 24.2994 9.2002",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 10.0002V9.2002H27.0996V9.6002C27.0996 9.70629 27.1418 9.80803 27.2168 9.88304C27.2918 9.95806 27.3935 10.0002 27.4996 10.0002",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 9.2002H27.8994V10.0002H28.6994V9.2002Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 9.2002H28.6997V10.0002H29.4997V9.2002Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 9.2002H29.4995V10.0002H30.2995V9.2002Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 9.2002H30.2998V10.0002H30.6998C30.8059 10.0002 30.9076 9.95805 30.9826 9.88304C31.0577 9.80802 31.0998 9.70627 31.0998 9.60019",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 9.2002H31.8994V10.0002H32.6994V9.2002Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 10.0002H34.2995V9.2002H33.8995C33.7934 9.2002 33.6917 9.24234 33.6167 9.31736C33.5416 9.39237 33.4995 9.49411 33.4995 9.6002",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 9.2002H34.2993V10.0002H35.0993V9.2002Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 9.2002H35.0996V10.0002H35.8996V9.2002Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 9.2002H35.8994V10.0002H36.6994V9.2002Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 10.0002H39.0993V9.6002C39.0993 9.49411 39.0572 9.39237 38.9822 9.31736C38.9071 9.24234 38.8054 9.2002 38.6993 9.2002C38.5932 9.2002 38.4915 9.24234 38.4165 9.31736C38.3415 9.39237 38.2993 9.49411 38.2993 9.6002",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 10.8H7.89961V10H7.49961C7.39353 10 7.29179 10.0421 7.21677 10.1172C7.14176 10.1922 7.09961 10.2939 7.09961 10.4",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89941 10V10.8H8.29941C8.4055 10.8 8.50724 10.7579 8.58225 10.6828C8.65727 10.6078 8.69941 10.5061 8.69941 10.4C8.69941 10.2939 8.65727 10.1922 8.58225 10.1172C8.50724 10.0421 8.4055 10 8.29941 10",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 10.8H10.2995V10H9.89951C9.79342 10 9.69168 10.0421 9.61666 10.1172C9.54165 10.1922 9.49951 10.2939 9.49951 10.4",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 10H10.2993V10.8H11.0993V10Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 10H11.0996V10.8H11.8996V10Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 10.8V10H12.6997V10.4C12.6997 10.5061 12.7418 10.6078 12.8169 10.6828C12.8919 10.7579 12.9936 10.8 13.0997 10.8",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 10H13.4995V10.8H14.2995V10Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 10H14.2993V10.8H15.0993V10Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 10H15.0996V10.8H15.4996C15.6057 10.8 15.7074 10.7579 15.7825 10.6828C15.8575 10.6078 15.8996 10.5061 15.8996 10.4",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 10.8V10H17.0997C16.9936 10 16.8919 10.0421 16.8169 10.1172C16.7418 10.1922 16.6997 10.2939 16.6997 10.4C16.6997 10.5061 16.7418 10.6078 16.8169 10.6828C16.8919 10.7579 16.9936 10.8 17.0997 10.8",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 10V10.8H17.8995C18.0056 10.8 18.1073 10.7579 18.1824 10.6828C18.2574 10.6078 18.2995 10.5061 18.2995 10.4C18.2995 10.2939 18.2574 10.1922 18.1824 10.1172C18.1073 10.0421 18.0056 10 17.8995 10",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 10.8H21.4997V10H21.0997C20.9936 10 20.8919 10.0421 20.8169 10.1172C20.7418 10.1922 20.6997 10.2939 20.6997 10.4",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 10V10.8H21.8995C22.0056 10.8 22.1073 10.7579 22.1824 10.6828C22.2574 10.6078 22.2995 10.5061 22.2995 10.4C22.2995 10.2939 22.2574 10.1922 22.1824 10.1172C22.1073 10.0421 22.0056 10 21.8995 10",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 10.8V10H23.0996V10.4C23.0996 10.5061 23.1418 10.6078 23.2168 10.6828C23.2918 10.7579 23.3935 10.8 23.4996 10.8",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 10H23.8999V10.8H24.2999C24.406 10.8 24.5077 10.7579 24.5827 10.6828C24.6578 10.6078 24.6999 10.5061 24.6999 10.4",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 10.8H26.2995V10H25.8995C25.7934 10 25.6917 10.0421 25.6167 10.1172C25.5416 10.1922 25.4995 10.2939 25.4995 10.4",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 10V10.8H26.6993C26.8054 10.8 26.9071 10.7579 26.9822 10.6828C27.0572 10.6078 27.0993 10.5061 27.0993 10.4C27.0993 10.2939 27.0572 10.1922 26.9822 10.1172C26.9071 10.0421 26.8054 10 26.6993 10",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 10.8V10H28.6997V10.4C28.6997 10.5061 28.7418 10.6078 28.8169 10.6828C28.8919 10.7579 28.9936 10.8 29.0997 10.8",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 10H29.4995V10.8H29.8995C30.0056 10.8 30.1073 10.7579 30.1824 10.6828C30.2574 10.6078 30.2995 10.5061 30.2995 10.4",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 10H31.8994V10.8H32.6994V10Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 10H32.6997V10.8H33.4997V10Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 10H33.4995V10.8H34.2995V10Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 10H34.2998V10.8H34.6998C34.8059 10.8 34.9076 10.7579 34.9826 10.6828C35.0577 10.6078 35.0998 10.5061 35.0998 10.4",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 10H35.8999V10.4C35.8999 10.5061 35.942 10.6078 36.0171 10.6828C36.0921 10.7579 36.1938 10.8 36.2999 10.8C36.406 10.8 36.5077 10.7579 36.5827 10.6828C36.6578 10.6078 36.6999 10.5061 36.6999 10.4",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0998 10H38.2998V10.4C38.2998 10.5061 38.3419 10.6078 38.417 10.6828C38.492 10.7579 38.5937 10.8 38.6998 10.8C38.8059 10.8 38.9076 10.7579 38.9826 10.6828C39.0577 10.6078 39.0998 10.5061 39.0998 10.4",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 11.6003H4.69941V11.2003C4.69941 11.0942 4.65727 10.9925 4.58225 10.9175C4.50724 10.8424 4.4055 10.8003 4.29941 10.8003C4.19332 10.8003 4.09158 10.8424 4.01657 10.9175C3.94155 10.9925 3.89941 11.0942 3.89941 11.2003",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 11.6003V10.8003H6.6998C6.59372 10.8003 6.49198 10.8424 6.41696 10.9175C6.34195 10.9925 6.2998 11.0942 6.2998 11.2003C6.2998 11.3064 6.34195 11.4081 6.41696 11.4831C6.49198 11.5582 6.59372 11.6003 6.6998 11.6003",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 10.7998H7.09961V11.5998H7.89961V10.7998Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 11.6003H9.49971V10.8003H9.09971C8.99363 10.8003 8.89188 10.8424 8.81687 10.9175C8.74185 10.9925 8.69971 11.0942 8.69971 11.2003",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 10.7998H9.49951V11.5998H10.2995V10.7998Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 10.7998H10.2993V11.5998H11.0993V10.7998Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 10.7998H11.0996V11.5998H11.8996V10.7998Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 10.7998V11.5998H12.2994C12.4055 11.5998 12.5072 11.5577 12.5823 11.4826C12.6573 11.4076 12.6994 11.3059 12.6994 11.1998C12.6994 11.0937 12.6573 10.992 12.5823 10.917C12.5072 10.8419 12.4055 10.7998 12.2994 10.7998",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 10.7998H13.4995V11.5998H14.2995V10.7998Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 11.6003V10.8003H20.2999C20.1938 10.8003 20.0921 10.8424 20.0171 10.9175C19.942 10.9925 19.8999 11.0942 19.8999 11.2003C19.8999 11.3064 19.942 11.4081 20.0171 11.4831C20.0921 11.5582 20.1938 11.6003 20.2999 11.6003",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 10.7998H20.6997V11.5998H21.4997V10.7998Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 10.7998H25.4995V11.5998H26.2995V10.7998Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 11.6003V10.8003H30.6998C30.5937 10.8003 30.492 10.8424 30.417 10.9175C30.3419 10.9925 30.2998 11.0942 30.2998 11.2003C30.2998 11.3064 30.3419 11.4081 30.417 11.4831C30.492 11.5582 30.5937 11.6003 30.6998 11.6003",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 10.7998H31.0996V11.5998H31.8996V10.7998Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 10.7998H31.8999V11.5998H32.2999C32.406 11.5998 32.5077 11.5577 32.5827 11.4826C32.6578 11.4076 32.6999 11.3059 32.6999 11.1998",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 11.5998C35.7205 11.5998 35.8996 11.4207 35.8996 11.1998C35.8996 10.9789 35.7205 10.7998 35.4996 10.7998C35.2787 10.7998 35.0996 10.9789 35.0996 11.1998C35.0996 11.4207 35.2787 11.5998 35.4996 11.5998Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8995 11.5998C38.1204 11.5998 38.2995 11.4207 38.2995 11.1998C38.2995 10.9789 38.1204 10.7998 37.8995 10.7998C37.6786 10.7998 37.4995 10.9789 37.4995 11.1998C37.4995 11.4207 37.6786 11.5998 37.8995 11.5998Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 11.6001H3.89941V12.4001H4.69941V11.6001Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 12.4001H6.29951V12.0001C6.29951 11.894 6.25736 11.7923 6.18235 11.7173C6.10734 11.6422 6.00559 11.6001 5.89951 11.6001C5.79342 11.6001 5.69168 11.6422 5.61666 11.7173C5.54165 11.7923 5.49951 11.894 5.49951 12.0001",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 12.4001V11.6001H7.09961V12.0001C7.09961 12.1062 7.14175 12.2079 7.21677 12.2829C7.29178 12.358 7.39352 12.4001 7.49961 12.4001",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 11.6001H7.89941V12.4001H8.69941V11.6001Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 11.6001H8.69971V12.4001H9.49971V11.6001Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 11.6001H10.2993V12.4001H11.0993V11.6001Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 11.6001H11.0996V12.4001H11.8996V11.6001Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 11.6001H13.4995V12.4001H14.2995V11.6001Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 11.6001V12.4001H15.0993V12.0001C15.0993 11.894 15.0572 11.7923 14.9822 11.7173C14.9071 11.6422 14.8054 11.6001 14.6993 11.6001",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2993 12.4001H19.0993V11.6001H18.6993C18.5932 11.6001 18.4915 11.6422 18.4165 11.7173C18.3415 11.7923 18.2993 11.894 18.2993 12.0001",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 11.6001V12.4001H19.8996V12.0001C19.8996 11.894 19.8575 11.7923 19.7824 11.7173C19.7074 11.6422 19.6057 11.6001 19.4996 11.6001",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 11.6001H20.6997V12.0001C20.6997 12.1062 20.7418 12.2079 20.8169 12.2829C20.8919 12.358 20.9936 12.4001 21.0997 12.4001C21.2058 12.4001 21.3075 12.358 21.3826 12.2829C21.4576 12.2079 21.4997 12.1062 21.4997 12.0001",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 12.4001V11.6001H23.4996C23.3935 11.6001 23.2918 11.6422 23.2168 11.7173C23.1418 11.7923 23.0996 11.894 23.0996 12.0001C23.0996 12.1062 23.1418 12.2079 23.2168 12.2829C23.2918 12.358 23.3935 12.4001 23.4996 12.4001",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6994 11.6001H23.8994V12.4001H24.6994V11.6001Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 11.6001H24.6997V12.4001H25.4997V11.6001Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 11.6001H25.4995V12.4001H26.2995V11.6001Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 11.6001V12.4001H27.0993V12.0001C27.0993 11.894 27.0572 11.7923 26.9822 11.7173C26.9071 11.6422 26.8054 11.6001 26.6993 11.6001",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 12.4001V11.6001H29.0997C28.9936 11.6001 28.8919 11.6422 28.8169 11.7173C28.7418 11.7923 28.6997 11.894 28.6997 12.0001C28.6997 12.1062 28.7418 12.2079 28.8169 12.2829C28.8919 12.358 28.9936 12.4001 29.0997 12.4001",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 11.6001V12.4001H29.8995C30.0056 12.4001 30.1073 12.358 30.1824 12.2829C30.2574 12.2079 30.2995 12.1062 30.2995 12.0001C30.2995 11.894 30.2574 11.7923 30.1824 11.7173C30.1073 11.6422 30.0056 11.6001 29.8995 11.6001",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 12.4001H33.4997V12.0001C33.4997 11.894 33.4576 11.7923 33.3825 11.7173C33.3075 11.6422 33.2058 11.6001 33.0997 11.6001C32.9936 11.6001 32.8919 11.6422 32.8169 11.7173C32.7418 11.7923 32.6997 11.894 32.6997 12.0001",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 12.4001V11.6001H36.2999C36.1938 11.6001 36.0921 11.6422 36.0171 11.7173C35.942 11.7923 35.8999 11.894 35.8999 12.0001C35.8999 12.1062 35.942 12.2079 36.0171 12.2829C36.0921 12.358 36.1938 12.4001 36.2999 12.4001",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 11.6001V12.4001H37.0997C37.2058 12.4001 37.3075 12.358 37.3825 12.2829C37.4576 12.2079 37.4997 12.1062 37.4997 12.0001C37.4997 11.894 37.4576 11.7923 37.3825 11.7173C37.3075 11.6422 37.2058 11.6001 37.0997 11.6001",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 13.2004H3.89961V12.4004H3.49961C3.39353 12.4004 3.29179 12.4425 3.21677 12.5176C3.14176 12.5926 3.09961 12.6943 3.09961 12.8004",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 12.3999H3.89941V13.1999H4.69941V12.3999Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 12.3999H4.69971V13.1999H5.49971V12.3999Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 12.3999H5.49951V13.1999H6.29951V12.3999Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29932 12.3999V13.1999H6.69932C6.80541 13.1999 6.90715 13.1578 6.98216 13.0827C7.05718 13.0077 7.09932 12.906 7.09932 12.7999C7.09932 12.6938 7.05718 12.5921 6.98216 12.5171C6.90715 12.442 6.80541 12.3999 6.69932 12.3999",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 12.3999H8.69971V13.1999H9.49971V12.3999Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 12.3999H9.49951V13.1999H10.2995V12.3999Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 12.3999H10.2993V13.1999H11.0993V12.3999Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 12.3999H11.0996V13.1999H11.8996V12.3999Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 12.3999V13.1999H12.6994V12.7999C12.6994 12.6938 12.6573 12.5921 12.5823 12.5171C12.5072 12.442 12.4055 12.3999 12.2994 12.3999",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 12.3999H13.4995V13.1999H14.2995V12.3999Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 12.3999H14.2993V13.1999H15.0993V12.3999Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 12.3999V13.1999H15.4996C15.6057 13.1999 15.7074 13.1578 15.7824 13.0827C15.8575 13.0077 15.8996 12.906 15.8996 12.7999C15.8996 12.6938 15.8575 12.5921 15.7824 12.5171C15.7074 12.442 15.6057 12.3999 15.4996 12.3999",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 13.2004V12.4004H18.2998V12.8004C18.2998 12.9065 18.3419 13.0082 18.417 13.0832C18.492 13.1583 18.5937 13.2004 18.6998 13.2004",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 12.3999H19.0996V13.1999H19.4996C19.6057 13.1999 19.7074 13.1578 19.7825 13.0827C19.8575 13.0077 19.8996 12.906 19.8996 12.7999",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 12.3999H23.8999V12.7999C23.8999 12.906 23.942 13.0077 24.0171 13.0827C24.0921 13.1578 24.1938 13.1999 24.2999 13.1999C24.406 13.1999 24.5077 13.1578 24.5827 13.0827C24.6578 13.0077 24.6999 12.906 24.6999 12.7999",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 12.3999H26.2998V12.7999C26.2998 12.906 26.3419 13.0077 26.417 13.0827C26.492 13.1578 26.5937 13.1999 26.6998 13.1999C26.8059 13.1999 26.9076 13.1578 26.9826 13.0827C27.0577 13.0077 27.0998 12.906 27.0998 12.7999",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 13.2004V12.4004H32.2999C32.1938 12.4004 32.0921 12.4425 32.0171 12.5176C31.942 12.5926 31.8999 12.6943 31.8999 12.8004C31.8999 12.9065 31.942 13.0082 32.0171 13.0832C32.0921 13.1583 32.1938 13.2004 32.2999 13.2004",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 12.3999H32.6997V13.1999H33.4997V12.3999Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 12.3999V13.1999H34.2995V12.7999C34.2995 12.6938 34.2574 12.5921 34.1824 12.5171C34.1073 12.442 34.0056 12.3999 33.8995 12.3999",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 13.1999C35.7205 13.1999 35.8996 13.0208 35.8996 12.7999C35.8996 12.579 35.7205 12.3999 35.4996 12.3999C35.2787 12.3999 35.0996 12.579 35.0996 12.7999C35.0996 13.0208 35.2787 13.1999 35.4996 13.1999Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 14.0002V13.2002H3.09961V13.6002C3.09961 13.7063 3.14175 13.808 3.21677 13.883C3.29178 13.9581 3.39352 14.0002 3.49961 14.0002",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 13.2002H3.8999V14.0002H4.2999C4.40599 14.0002 4.50773 13.9581 4.58275 13.883C4.65776 13.808 4.6999 13.7063 4.6999 13.6002",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 13.2002H5.49951V13.6002C5.49951 13.7063 5.54165 13.808 5.61667 13.883C5.69168 13.9581 5.79343 14.0002 5.89951 14.0002C6.0056 14.0002 6.10734 13.9581 6.18235 13.883C6.25737 13.808 6.29951 13.7063 6.29951 13.6002",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 14.0002V13.2002H7.49961C7.39352 13.2002 7.29178 13.2423 7.21677 13.3174C7.14175 13.3924 7.09961 13.4941 7.09961 13.6002C7.09961 13.7063 7.14175 13.808 7.21677 13.883C7.29178 13.9581 7.39352 14.0002 7.49961 14.0002",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 13.2002H7.89941V14.0002H8.69941V13.2002Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 13.2002H8.69971V14.0002H9.09971C9.20579 14.0002 9.30754 13.9581 9.38255 13.883C9.45756 13.808 9.49971 13.7063 9.49971 13.6002",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 14.0002V13.2002H11.8999V13.6002C11.8999 13.7063 11.942 13.808 12.0171 13.883C12.0921 13.9581 12.1938 14.0002 12.2999 14.0002",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 13.2002H12.6997V14.0002H13.4997V13.2002Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 13.2002H13.4995V14.0002H14.2995V13.2002Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 14.0002H17.4997V13.2002H17.0997C16.9936 13.2002 16.8919 13.2423 16.8169 13.3174C16.7418 13.3924 16.6997 13.4941 16.6997 13.6002",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 13.2002V14.0002H18.2995V13.6002C18.2995 13.4941 18.2574 13.3924 18.1824 13.3174C18.1073 13.2423 18.0056 13.2002 17.8995 13.2002",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 14.0002V13.2002H20.2999C20.1938 13.2002 20.0921 13.2423 20.0171 13.3174C19.942 13.3924 19.8999 13.4941 19.8999 13.6002C19.8999 13.7063 19.942 13.808 20.0171 13.883C20.0921 13.9581 20.1938 14.0002 20.2999 14.0002",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 13.2002V14.0002H21.0997C21.2058 14.0002 21.3075 13.9581 21.3825 13.883C21.4576 13.808 21.4997 13.7063 21.4997 13.6002C21.4997 13.4941 21.4576 13.3924 21.3825 13.3174C21.3075 13.2423 21.2058 13.2002 21.0997 13.2002",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4996 14.0002C23.7205 14.0002 23.8996 13.8211 23.8996 13.6002C23.8996 13.3793 23.7205 13.2002 23.4996 13.2002C23.2787 13.2002 23.0996 13.3793 23.0996 13.6002C23.0996 13.8211 23.2787 14.0002 23.4996 14.0002Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 14.0002H25.4997V13.6002C25.4997 13.4941 25.4576 13.3924 25.3825 13.3174C25.3075 13.2423 25.2058 13.2002 25.0997 13.2002C24.9936 13.2002 24.8919 13.2423 24.8169 13.3174C24.7418 13.3924 24.6997 13.4941 24.6997 13.6002",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 14.0002H27.8996V13.2002H27.4996C27.3935 13.2002 27.2918 13.2423 27.2168 13.3174C27.1417 13.3924 27.0996 13.4941 27.0996 13.6002",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 13.2002V14.0002H28.6994V13.6002C28.6994 13.4941 28.6573 13.3924 28.5823 13.3174C28.5072 13.2423 28.4055 13.2002 28.2994 13.2002",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 13.2002H33.4995V13.6002C33.4995 13.7063 33.5417 13.808 33.6167 13.883C33.6917 13.9581 33.7934 14.0002 33.8995 14.0002C34.0056 14.0002 34.1073 13.9581 34.1824 13.883C34.2574 13.808 34.2995 13.7063 34.2995 13.6002",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2994 14.0002C36.5203 14.0002 36.6994 13.8211 36.6994 13.6002C36.6994 13.3793 36.5203 13.2002 36.2994 13.2002C36.0785 13.2002 35.8994 13.3793 35.8994 13.6002C35.8994 13.8211 36.0785 14.0002 36.2994 14.0002Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8995 14.0002C38.1204 14.0002 38.2995 13.8211 38.2995 13.6002C38.2995 13.3793 38.1204 13.2002 37.8995 13.2002C37.6786 13.2002 37.4995 13.3793 37.4995 13.6002C37.4995 13.8211 37.6786 14.0002 37.8995 14.0002Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 14.8H10.2995V14H9.89951C9.79342 14 9.69168 14.0421 9.61666 14.1172C9.54165 14.1922 9.49951 14.2939 9.49951 14.4",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 14V14.8H11.0993V14.4C11.0993 14.2939 11.0572 14.1922 10.9822 14.1172C10.9071 14.0421 10.8054 14 10.6993 14",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 14H13.4995V14.8H14.2995V14Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 14.8H16.6994V14H16.2994C16.1933 14 16.0916 14.0421 16.0166 14.1172C15.9416 14.1922 15.8994 14.2939 15.8994 14.4",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 14H16.6997V14.8H17.4997V14Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 14H17.4995V14.8H17.8995C18.0056 14.8 18.1073 14.7579 18.1824 14.6828C18.2574 14.6078 18.2995 14.5061 18.2995 14.4",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 14.8C19.7205 14.8 19.8996 14.6209 19.8996 14.4C19.8996 14.1791 19.7205 14 19.4996 14C19.2787 14 19.0996 14.1791 19.0996 14.4C19.0996 14.6209 19.2787 14.8 19.4996 14.8Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 14.8V14H21.8995C21.7934 14 21.6917 14.0421 21.6167 14.1172C21.5417 14.1922 21.4995 14.2939 21.4995 14.4C21.4995 14.5061 21.5417 14.6078 21.6167 14.6828C21.6917 14.7579 21.7934 14.8 21.8995 14.8",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2993 14V14.8H23.0993V14.4C23.0993 14.2939 23.0572 14.1922 22.9822 14.1172C22.9071 14.0421 22.8054 14 22.6993 14",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 14.8H24.6994V14H24.2994C24.1933 14 24.0916 14.0421 24.0166 14.1172C23.9416 14.1922 23.8994 14.2939 23.8994 14.4",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 14H24.6997V14.8H25.4997V14Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 14H27.0996V14.8H27.8996V14Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 14H27.8999V14.8H28.2999C28.406 14.8 28.5077 14.7579 28.5827 14.6828C28.6578 14.6078 28.6999 14.5061 28.6999 14.4",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 14.8V14H32.2999C32.1938 14 32.0921 14.0421 32.0171 14.1172C31.942 14.1922 31.8999 14.2939 31.8999 14.4C31.8999 14.5061 31.942 14.6078 32.0171 14.6828C32.0921 14.7579 32.1938 14.8 32.2999 14.8",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 14V14.8H33.0997C33.2058 14.8 33.3075 14.7579 33.3825 14.6828C33.4576 14.6078 33.4997 14.5061 33.4997 14.4C33.4997 14.2939 33.4576 14.1922 33.3825 14.1172C33.3075 14.0421 33.2058 14 33.0997 14",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0997 14.8C37.3206 14.8 37.4997 14.6209 37.4997 14.4C37.4997 14.1791 37.3206 14 37.0997 14C36.8788 14 36.6997 14.1791 36.6997 14.4C36.6997 14.6209 36.8788 14.8 37.0997 14.8Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 15.6003H3.89961V15.2003C3.89961 15.0942 3.85747 14.9925 3.78246 14.9175C3.70744 14.8424 3.6057 14.8003 3.49961 14.8003C3.39353 14.8003 3.29179 14.8424 3.21677 14.9175C3.14176 14.9925 3.09961 15.0942 3.09961 15.2003",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 15.6003V14.8003H5.09971C4.99362 14.8003 4.89188 14.8424 4.81686 14.9175C4.74185 14.9925 4.69971 15.0942 4.69971 15.2003C4.69971 15.3064 4.74185 15.4081 4.81686 15.4831C4.89188 15.5582 4.99362 15.6003 5.09971 15.6003",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 14.7998V15.5998H5.89951C6.00559 15.5998 6.10733 15.5577 6.18235 15.4826C6.25736 15.4076 6.29951 15.3059 6.29951 15.1998C6.29951 15.0937 6.25736 14.992 6.18235 14.917C6.10733 14.8419 6.00559 14.7998 5.89951 14.7998",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 15.6003V14.8003H8.2999C8.19382 14.8003 8.09207 14.8424 8.01706 14.9175C7.94205 14.9925 7.8999 15.0942 7.8999 15.2003C7.8999 15.3064 7.94205 15.4081 8.01706 15.4831C8.09207 15.5582 8.19382 15.6003 8.2999 15.6003",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 14.7998H8.69971V15.5998H9.49971V14.7998Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 14.7998H9.49951V15.5998H10.2995V14.7998Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 14.7998H10.2993V15.5998H11.0993V14.7998Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 15.6003V14.8003H13.0997C12.9936 14.8003 12.8919 14.8424 12.8169 14.9175C12.7418 14.9925 12.6997 15.0942 12.6997 15.2003C12.6997 15.3064 12.7418 15.4081 12.8169 15.4831C12.8919 15.5582 12.9936 15.6003 13.0997 15.6003",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 14.7998H13.4995V15.5998H13.8995C14.0056 15.5998 14.1073 15.5577 14.1824 15.4826C14.2574 15.4076 14.2995 15.3059 14.2995 15.1998",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 14.7998H15.8994V15.5998H16.6994V14.7998Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 14.7998H16.6997V15.5998H17.0997C17.2058 15.5998 17.3075 15.5577 17.3826 15.4826C17.4576 15.4076 17.4997 15.3059 17.4997 15.1998",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8994 15.6003H20.6994V15.2003C20.6994 15.0942 20.6573 14.9925 20.5823 14.9175C20.5072 14.8424 20.4055 14.8003 20.2994 14.8003C20.1933 14.8003 20.0916 14.8424 20.0166 14.9175C19.9416 14.9925 19.8994 15.0942 19.8994 15.2003",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 14.7998H22.2998V15.1998C22.2998 15.3059 22.3419 15.4076 22.417 15.4826C22.492 15.5577 22.5937 15.5998 22.6998 15.5998C22.8059 15.5998 22.9076 15.5577 22.9826 15.4826C23.0577 15.4076 23.0998 15.3059 23.0998 15.1998",
    fill: "white"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 15.6003V14.8003H23.8999V15.2003C23.8999 15.3064 23.942 15.4081 24.0171 15.4831C24.0921 15.5582 24.1938 15.6003 24.2999 15.6003",
    fill: "white"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 14.7998H24.6997V15.5998H25.4997V14.7998Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 14.7998V15.5998H26.2995V15.1998C26.2995 15.0937 26.2574 14.992 26.1824 14.917C26.1073 14.8419 26.0056 14.7998 25.8995 14.7998",
    fill: "white"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 14.7998H27.0996V15.5998H27.8996V14.7998Z",
    fill: "white"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 15.6003H29.4997V14.8003H29.0997C28.9936 14.8003 28.8919 14.8424 28.8169 14.9175C28.7418 14.9925 28.6997 15.0942 28.6997 15.2003",
    fill: "white"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 14.7998H29.4995V15.5998H30.2995V14.7998Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 14.7998H30.2993V15.5998H31.0993V14.7998Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 14.7998V15.5998H31.8996V15.1998C31.8996 15.0937 31.8575 14.992 31.7824 14.917C31.7074 14.8419 31.6057 14.7998 31.4996 14.7998",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 15.6003V14.8003H33.8995C33.7934 14.8003 33.6917 14.8424 33.6167 14.9175C33.5417 14.9925 33.4995 15.0942 33.4995 15.2003C33.4995 15.3064 33.5417 15.4081 33.6167 15.4831C33.6917 15.5582 33.7934 15.6003 33.8995 15.6003",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2993 14.7998V15.5998H34.6993C34.8054 15.5998 34.9071 15.5577 34.9822 15.4826C35.0572 15.4076 35.0993 15.3059 35.0993 15.1998C35.0993 15.0937 35.0572 14.992 34.9822 14.917C34.9071 14.8419 34.8054 14.7998 34.6993 14.7998",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2994 15.5998C36.5203 15.5998 36.6994 15.4207 36.6994 15.1998C36.6994 14.9789 36.5203 14.7998 36.2994 14.7998C36.0785 14.7998 35.8994 14.9789 35.8994 15.1998C35.8994 15.4207 36.0785 15.5998 36.2994 15.5998Z",
    fill: "white"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 15.6003H38.2995V15.2003C38.2995 15.0942 38.2574 14.9925 38.1824 14.9175C38.1073 14.8424 38.0056 14.8003 37.8995 14.8003C37.7934 14.8003 37.6917 14.8424 37.6167 14.9175C37.5416 14.9925 37.4995 15.0942 37.4995 15.2003",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 15.6001H3.09961V16.0001C3.09961 16.1062 3.14175 16.2079 3.21677 16.2829C3.29178 16.358 3.39352 16.4001 3.49961 16.4001C3.6057 16.4001 3.70744 16.358 3.78245 16.2829C3.85747 16.2079 3.89961 16.1062 3.89961 16.0001",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09961 16.4001H7.89961V16.0001C7.89961 15.894 7.85747 15.7923 7.78246 15.7173C7.70744 15.6422 7.6057 15.6001 7.49961 15.6001C7.39353 15.6001 7.29179 15.6422 7.21677 15.7173C7.14176 15.7923 7.09961 15.894 7.09961 16.0001",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 16.4001V15.6001H8.69971V16.0001C8.69971 16.1062 8.74185 16.2079 8.81686 16.2829C8.89188 16.358 8.99362 16.4001 9.09971 16.4001",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 15.6001H9.49951V16.4001H10.2995V15.6001Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 15.6001H10.2993V16.4001H11.0993V15.6001Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 15.6001V16.4001H11.8996V16.0001C11.8996 15.894 11.8575 15.7923 11.7824 15.7173C11.7074 15.6422 11.6057 15.6001 11.4996 15.6001",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 15.6001H15.8994V16.4001H16.6994V15.6001Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 16.4001V15.6001H17.8995C17.7934 15.6001 17.6917 15.6422 17.6167 15.7173C17.5417 15.7923 17.4995 15.894 17.4995 16.0001C17.4995 16.1062 17.5417 16.2079 17.6167 16.2829C17.6917 16.358 17.7934 16.4001 17.8995 16.4001",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 15.6001H18.2993V16.4001H19.0993V15.6001Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 15.6001H19.0996V16.4001H19.8996V15.6001Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 15.6001H19.8999V16.4001H20.2999C20.406 16.4001 20.5077 16.358 20.5827 16.2829C20.6578 16.2079 20.6999 16.1062 20.6999 16.0001",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8995 16.4001C22.1204 16.4001 22.2995 16.221 22.2995 16.0001C22.2995 15.7792 22.1204 15.6001 21.8995 15.6001C21.6786 15.6001 21.4995 15.7792 21.4995 16.0001C21.4995 16.221 21.6786 16.4001 21.8995 16.4001Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4996 16.4001C23.7205 16.4001 23.8996 16.221 23.8996 16.0001C23.8996 15.7792 23.7205 15.6001 23.4996 15.6001C23.2787 15.6001 23.0996 15.7792 23.0996 16.0001C23.0996 16.221 23.2787 16.4001 23.4996 16.4001Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 15.6001H24.6997V16.4001H25.4997V15.6001Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 15.6001H25.4995V16.4001H26.2995V15.6001Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 15.6001H26.2993V16.4001H27.0993V15.6001Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 15.6001H27.0996V16.4001H27.8996V15.6001Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 15.6001H28.6997V16.4001H29.4997V15.6001Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 16.4001V15.6001H30.2998V16.0001C30.2998 16.1062 30.3419 16.2079 30.417 16.2829C30.492 16.358 30.5937 16.4001 30.6998 16.4001",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 15.6001H31.0996V16.4001H31.8996V15.6001Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 15.6001V16.4001H32.6994V16.0001C32.6994 15.894 32.6573 15.7923 32.5823 15.7173C32.5072 15.6422 32.4055 15.6001 32.2994 15.6001",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 16.4001C35.7205 16.4001 35.8996 16.221 35.8996 16.0001C35.8996 15.7792 35.7205 15.6001 35.4996 15.6001C35.2787 15.6001 35.0996 15.7792 35.0996 16.0001C35.0996 16.221 35.2787 16.4001 35.4996 16.4001Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 16.4001H37.4997V15.6001H37.0997C36.9936 15.6001 36.8919 15.6422 36.8169 15.7173C36.7418 15.7923 36.6997 15.894 36.6997 16.0001",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 15.6001H37.4995V16.4001H38.2995V15.6001Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 15.6001V16.4001H39.0993V16.0001C39.0993 15.894 39.0572 15.7923 38.9822 15.7173C38.9071 15.6422 38.8054 15.6001 38.6993 15.6001",
    fill: "white"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89951 17.1999C6.12042 17.1999 6.29951 17.0208 6.29951 16.7999C6.29951 16.579 6.12042 16.3999 5.89951 16.3999C5.67859 16.3999 5.49951 16.579 5.49951 16.7999C5.49951 17.0208 5.67859 17.1999 5.89951 17.1999Z",
    fill: "white"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 17.2004V16.4004H7.09961V16.8004C7.09961 16.9065 7.14175 17.0082 7.21677 17.0832C7.29178 17.1583 7.39352 17.2004 7.49961 17.2004",
    fill: "white"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89941 16.3999V17.1999H8.29941C8.4055 17.1999 8.50724 17.1578 8.58225 17.0827C8.65727 17.0077 8.69941 16.906 8.69941 16.7999C8.69941 16.6938 8.65727 16.5921 8.58225 16.5171C8.50724 16.442 8.4055 16.3999 8.29941 16.3999",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 16.3999H9.49951V16.7999C9.49951 16.906 9.54165 17.0077 9.61667 17.0827C9.69168 17.1578 9.79343 17.1999 9.89951 17.1999C10.0056 17.1999 10.1073 17.1578 10.1824 17.0827C10.2574 17.0077 10.2995 16.906 10.2995 16.7999",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 16.3999H11.0996V17.1999H11.8996V16.3999Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 17.2004H14.2995V16.8004C14.2995 16.6943 14.2574 16.5926 14.1824 16.5176C14.1073 16.4425 14.0056 16.4004 13.8995 16.4004C13.7934 16.4004 13.6917 16.4425 13.6167 16.5176C13.5416 16.5926 13.4995 16.6943 13.4995 16.8004",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 16.3999H15.8994V17.1999H16.6994V16.3999Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 16.3999V17.1999H17.0997C17.2058 17.1999 17.3075 17.1578 17.3825 17.0827C17.4576 17.0077 17.4997 16.906 17.4997 16.7999C17.4997 16.6938 17.4576 16.5921 17.3825 16.5171C17.3075 16.442 17.2058 16.3999 17.0997 16.3999",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 17.2004V16.4004H24.6997V16.8004C24.6997 16.9065 24.7418 17.0082 24.8169 17.0832C24.8919 17.1583 24.9936 17.2004 25.0997 17.2004",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 16.3999H25.4995V17.1999H25.8995C26.0056 17.1999 26.1073 17.1578 26.1824 17.0827C26.2574 17.0077 26.2995 16.906 26.2995 16.7999",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 17.2004V16.4004H27.0996V16.8004C27.0996 16.9065 27.1418 17.0082 27.2168 17.0832C27.2918 17.1583 27.3935 17.2004 27.4996 17.2004",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 16.3999H27.8994V17.1999H28.6994V16.3999Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 16.3999H28.6997V17.1999H29.4997V16.3999Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 16.3999V17.1999H30.2995V16.7999C30.2995 16.6938 30.2574 16.5921 30.1824 16.5171C30.1073 16.442 30.0056 16.3999 29.8995 16.3999",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 16.3999H31.8994V17.1999H32.6994V16.3999Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 16.3999V17.1999H33.4997V16.7999C33.4997 16.6938 33.4576 16.5921 33.3825 16.5171C33.3075 16.442 33.2058 16.3999 33.0997 16.3999",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 17.2004V16.4004H36.2999C36.1938 16.4004 36.0921 16.4425 36.0171 16.5176C35.942 16.5926 35.8999 16.6943 35.8999 16.8004C35.8999 16.9065 35.942 17.0082 36.0171 17.0832C36.0921 17.1583 36.1938 17.2004 36.2999 17.2004",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 16.3999H36.6997V17.1999H37.4997V16.3999Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 16.3999H37.4995V17.1999H38.2995V16.3999Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0998 16.3999H38.2998V17.1999H38.6998C38.8059 17.1999 38.9076 17.1578 38.9826 17.0827C39.0577 17.0077 39.0998 16.906 39.0998 16.7999",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 18.0002H3.89961V17.2002H3.49961C3.39353 17.2002 3.29179 17.2423 3.21677 17.3174C3.14176 17.3924 3.09961 17.4941 3.09961 17.6002",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 17.2002V18.0002H4.29941C4.4055 18.0002 4.50724 17.9581 4.58225 17.883C4.65727 17.808 4.69941 17.7063 4.69941 17.6002C4.69941 17.4941 4.65727 17.3924 4.58225 17.3174C4.50724 17.2423 4.4055 17.2002 4.29941 17.2002",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29932 18.0002H7.09932V17.6002C7.09932 17.4941 7.05718 17.3924 6.98216 17.3174C6.90715 17.2423 6.80541 17.2002 6.69932 17.2002C6.59324 17.2002 6.49149 17.2423 6.41648 17.3174C6.34146 17.3924 6.29932 17.4941 6.29932 17.6002",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 18.0002H9.49971V17.6002C9.49971 17.4941 9.45757 17.3924 9.38256 17.3174C9.30754 17.2423 9.2058 17.2002 9.09971 17.2002C8.99363 17.2002 8.89188 17.2423 8.81687 17.3174C8.74185 17.3924 8.69971 17.4941 8.69971 17.6002",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 17.2002H11.0996V17.6002C11.0996 17.7063 11.1418 17.808 11.2168 17.883C11.2918 17.9581 11.3935 18.0002 11.4996 18.0002C11.6057 18.0002 11.7074 17.9581 11.7825 17.883C11.8575 17.808 11.8996 17.7063 11.8996 17.6002",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 18.0002V17.2002H13.0997C12.9936 17.2002 12.8919 17.2423 12.8169 17.3174C12.7418 17.3924 12.6997 17.4941 12.6997 17.6002C12.6997 17.7063 12.7418 17.808 12.8169 17.883C12.8919 17.9581 12.9936 18.0002 13.0997 18.0002",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 17.2002H13.4995V18.0002H14.2995V17.2002Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 17.2002H14.2993V18.0002H15.0993V17.2002Z",
    fill: "white"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 17.2002H15.0996V18.0002H15.8996V17.2002Z",
    fill: "white"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 17.2002H15.8994V18.0002H16.6994V17.2002Z",
    fill: "white"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6993 18.0002C26.9202 18.0002 27.0993 17.8211 27.0993 17.6002C27.0993 17.3793 26.9202 17.2002 26.6993 17.2002C26.4784 17.2002 26.2993 17.3793 26.2993 17.6002C26.2993 17.8211 26.4784 18.0002 26.6993 18.0002Z",
    fill: "white"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 17.2002H29.4995V18.0002H30.2995V17.2002Z",
    fill: "white"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 17.2002V18.0002H30.6993C30.8054 18.0002 30.9071 17.9581 30.9822 17.883C31.0572 17.808 31.0993 17.7063 31.0993 17.6002C31.0993 17.4941 31.0572 17.3924 30.9822 17.3174C30.9071 17.2423 30.8054 17.2002 30.6993 17.2002",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 17.2002H31.8994V18.0002H32.6994V17.2002Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 17.2002H32.6997V18.0002H33.4997V17.2002Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 17.2002V18.0002H34.2995V17.6002C34.2995 17.4941 34.2574 17.3924 34.1824 17.3174C34.1073 17.2423 34.0056 17.2002 33.8995 17.2002",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 18.0002H35.8996V17.6002C35.8996 17.4941 35.8575 17.3924 35.7824 17.3174C35.7074 17.2423 35.6057 17.2002 35.4996 17.2002C35.3935 17.2002 35.2918 17.2423 35.2168 17.3174C35.1417 17.3924 35.0996 17.4941 35.0996 17.6002",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 17.2002H36.6997V17.6002C36.6997 17.7063 36.7418 17.808 36.8169 17.883C36.8919 17.9581 36.9936 18.0002 37.0997 18.0002C37.2058 18.0002 37.3075 17.9581 37.3826 17.883C37.4576 17.808 37.4997 17.7063 37.4997 17.6002",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 18H3.09961V18.8H3.89961V18Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 18.8V18H5.89951C5.79343 18 5.69168 18.0421 5.61667 18.1172C5.54165 18.1922 5.49951 18.2939 5.49951 18.4C5.49951 18.5061 5.54165 18.6078 5.61667 18.6828C5.69168 18.7579 5.79343 18.8 5.89951 18.8",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 18H6.29932V18.8H7.09932V18Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 18H7.09961V18.8H7.89961V18Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 18H7.89941V18.8H8.69941V18Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 18H8.69971V18.8H9.49971V18Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 18H9.49951V18.8H10.2995V18Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 18V18.8H11.0993V18.4C11.0993 18.2939 11.0572 18.1922 10.9822 18.1172C10.9071 18.0421 10.8054 18 10.6993 18",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2994 18.8C12.5203 18.8 12.6994 18.6209 12.6994 18.4C12.6994 18.1791 12.5203 18 12.2994 18C12.0785 18 11.8994 18.1791 11.8994 18.4C11.8994 18.6209 12.0785 18.8 12.2994 18.8Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 18H13.4995V18.8H14.2995V18Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 18H14.2993V18.8H15.0993V18Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 18.8V18H15.8999V18.4C15.8999 18.5061 15.942 18.6078 16.0171 18.6828C16.0921 18.7579 16.1938 18.8 16.2999 18.8",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 18V18.8H17.4997V18.4C17.4997 18.2939 17.4576 18.1922 17.3825 18.1172C17.3075 18.0421 17.2058 18 17.0997 18",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0997 18.8C25.3206 18.8 25.4997 18.6209 25.4997 18.4C25.4997 18.1791 25.3206 18 25.0997 18C24.8788 18 24.6997 18.1791 24.6997 18.4C24.6997 18.6209 24.8788 18.8 25.0997 18.8Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 18.8H28.6994V18.4C28.6994 18.2939 28.6573 18.1922 28.5823 18.1172C28.5072 18.0421 28.4055 18 28.2994 18C28.1933 18 28.0916 18.0421 28.0166 18.1172C27.9416 18.1922 27.8994 18.2939 27.8994 18.4",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 18H29.4995V18.8H30.2995V18Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 18H31.8994V18.8H32.6994V18Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 18H32.6997V18.8H33.4997V18Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 18H33.4995V18.8H34.2995V18Z",
    fill: "white"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 18H34.2993V18.8H35.0993V18Z",
    fill: "white"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 18H35.0996V18.8H35.8996V18Z",
    fill: "white"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 18V18.8H36.2994C36.4055 18.8 36.5072 18.7579 36.5823 18.6828C36.6573 18.6078 36.6994 18.5061 36.6994 18.4C36.6994 18.2939 36.6573 18.1922 36.5823 18.1172C36.5072 18.0421 36.4055 18 36.2994 18",
    fill: "white"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 18.8H38.2995V18.4C38.2995 18.2939 38.2574 18.1922 38.1824 18.1172C38.1073 18.0421 38.0056 18 37.8995 18C37.7934 18 37.6917 18.0421 37.6167 18.1172C37.5416 18.1922 37.4995 18.2939 37.4995 18.4",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 18.7998H3.09961V19.5998H3.89961V18.7998Z",
    fill: "white"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 18.7998H6.29932V19.5998H7.09932V18.7998Z",
    fill: "white"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 18.7998H9.49951V19.5998H10.2995V18.7998Z",
    fill: "white"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 18.7998H10.2993V19.5998H11.0993V18.7998Z",
    fill: "white"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 18.7998V19.5998H11.8996V19.1998C11.8996 19.0937 11.8575 18.992 11.7824 18.917C11.7074 18.8419 11.6057 18.7998 11.4996 18.7998",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 18.7998H13.4995V19.5998H14.2995V18.7998Z",
    fill: "white"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 18.7998H14.2993V19.5998H15.0993V18.7998Z",
    fill: "white"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 18.7998H16.6997V19.5998H17.4997V18.7998Z",
    fill: "white"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4995 19.6003H26.2995V18.8003H25.8995C25.7934 18.8003 25.6917 18.8424 25.6167 18.9175C25.5416 18.9925 25.4995 19.0942 25.4995 19.2003",
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 18.7998V19.5998H27.0993V19.1998C27.0993 19.0937 27.0572 18.992 26.9822 18.917C26.9071 18.8419 26.8054 18.7998 26.6993 18.7998",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 18.7998H27.8994V19.5998H28.6994V18.7998Z",
    fill: "white"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 18.7998H28.6997V19.5998H29.4997V18.7998Z",
    fill: "white"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 18.7998H29.4995V19.5998H30.2995V18.7998Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 18.7998H31.8994V19.5998H32.6994V18.7998Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 18.7998H35.0996V19.5998H35.8996V18.7998Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 18.7998H37.4995V19.5998H38.2995V18.7998Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 19.6001H3.09961V20.4001H3.89961V19.6001Z",
    fill: "white"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 19.6001H6.29932V20.4001H7.09932V19.6001Z",
    fill: "white"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29941 20.4001C8.52032 20.4001 8.69941 20.221 8.69941 20.0001C8.69941 19.7792 8.52032 19.6001 8.29941 19.6001C8.0785 19.6001 7.89941 19.7792 7.89941 20.0001C7.89941 20.221 8.0785 20.4001 8.29941 20.4001Z",
    fill: "white"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 19.6001H9.49951V20.4001H10.2995V19.6001Z",
    fill: "white"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 19.6001H10.2993V20.4001H11.0993V19.6001Z",
    fill: "white"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 19.6001H11.0996V20.4001H11.8996V19.6001Z",
    fill: "white"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 19.6001V20.4001H12.6994V20.0001C12.6994 19.894 12.6573 19.7923 12.5823 19.7173C12.5072 19.6422 12.4055 19.6001 12.2994 19.6001",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 20.4001V19.6001H13.4995V20.0001C13.4995 20.1062 13.5417 20.2079 13.6167 20.2829C13.6917 20.358 13.7934 20.4001 13.8995 20.4001",
    fill: "white"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 19.6001H14.2993V20.4001H15.0993V19.6001Z",
    fill: "white"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 19.6001V20.4001H15.8996V20.0001C15.8996 19.894 15.8575 19.7923 15.7824 19.7173C15.7074 19.6422 15.6057 19.6001 15.4996 19.6001",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 19.6001H16.6997V20.0001C16.6997 20.1062 16.7418 20.2079 16.8169 20.2829C16.8919 20.358 16.9936 20.4001 17.0997 20.4001C17.2058 20.4001 17.3075 20.358 17.3826 20.2829C17.4576 20.2079 17.4997 20.1062 17.4997 20.0001",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 19.6001H25.4995V20.4001H26.2995V19.6001Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 19.6001H26.2993V20.4001H27.0993V19.6001Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 19.6001H27.0996V20.4001H27.8996V19.6001Z",
    fill: "white"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 19.6001H27.8994V20.4001H28.6994V19.6001Z",
    fill: "white"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 19.6001H29.4995V20.0001C29.4995 20.1062 29.5417 20.2079 29.6167 20.2829C29.6917 20.358 29.7934 20.4001 29.8995 20.4001C30.0056 20.4001 30.1073 20.358 30.1824 20.2829C30.2574 20.2079 30.2995 20.1062 30.2995 20.0001",
    fill: "white"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 19.6001H31.8994V20.4001H32.6994V19.6001Z",
    fill: "white"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8995 20.4001C34.1204 20.4001 34.2995 20.221 34.2995 20.0001C34.2995 19.7792 34.1204 19.6001 33.8995 19.6001C33.6786 19.6001 33.4995 19.7792 33.4995 20.0001C33.4995 20.221 33.6786 20.4001 33.8995 20.4001Z",
    fill: "white"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 19.6001H35.0996V20.4001H35.8996V19.6001Z",
    fill: "white"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 20.4001H37.4997V19.6001H37.0997C36.9936 19.6001 36.8919 19.6422 36.8169 19.7173C36.7418 19.7923 36.6997 19.894 36.6997 20.0001",
    fill: "white"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 19.6001H37.4995V20.4001H38.2995V19.6001Z",
    fill: "white"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 19.6001V20.4001H39.0993V20.0001C39.0993 19.894 39.0572 19.7923 38.9822 19.7173C38.9071 19.6422 38.8054 19.6001 38.6993 19.6001",
    fill: "white"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 20.3999H3.09961V21.1999H3.89961V20.3999Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 20.3999H3.89941V21.1999H4.69941V20.3999Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 20.3999V21.1999H5.09971C5.2058 21.1999 5.30754 21.1578 5.38255 21.0827C5.45757 21.0077 5.49971 20.906 5.49971 20.7999C5.49971 20.6938 5.45757 20.5921 5.38255 20.5171C5.30754 20.442 5.2058 20.3999 5.09971 20.3999",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 20.3999H6.29932V21.1999H7.09932V20.3999Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 20.3999H9.49951V21.1999H10.2995V20.3999Z",
    fill: "white"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 20.3999H10.2993V21.1999H11.0993V20.3999Z",
    fill: "white"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 20.3999H11.0996V21.1999H11.8996V20.3999Z",
    fill: "white"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 20.3999H11.8994V21.1999H12.6994V20.3999Z",
    fill: "white"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 20.3999V21.1999H13.0997C13.2058 21.1999 13.3075 21.1578 13.3825 21.0827C13.4576 21.0077 13.4997 20.906 13.4997 20.7999C13.4997 20.6938 13.4576 20.5921 13.3825 20.5171C13.3075 20.442 13.2058 20.3999 13.0997 20.3999",
    fill: "white"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 20.3999H14.2993V21.1999H15.0993V20.3999Z",
    fill: "white"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 20.3999H15.0996V21.1999H15.8996V20.3999Z",
    fill: "white"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 20.3999H25.4995V21.1999H26.2995V20.3999Z",
    fill: "white"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 20.3999H26.2993V21.1999H27.0993V20.3999Z",
    fill: "white"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 20.3999H27.0996V21.1999H27.8996V20.3999Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 20.3999H27.8994V21.1999H28.6994V20.3999Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 21.2004H31.0993V20.4004H30.6993C30.5932 20.4004 30.4915 20.4425 30.4165 20.5176C30.3415 20.5926 30.2993 20.6943 30.2993 20.8004",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 20.3999H31.0996V21.1999H31.8996V20.3999Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 20.3999H31.8994V21.1999H32.6994V20.3999Z",
    fill: "white"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 20.3999H35.0996V21.1999H35.8996V20.3999Z",
    fill: "white"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 20.3999H35.8994V21.1999H36.6994V20.3999Z",
    fill: "white"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 20.3999H36.6997V21.1999H37.4997V20.3999Z",
    fill: "white"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 20.3999H37.4995V21.1999H38.2995V20.3999Z",
    fill: "white"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 20.3999H38.2993V21.1999H39.0993V20.3999Z",
    fill: "white"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 21.2002H3.09961V22.0002H3.89961V21.2002Z",
    fill: "white"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 21.2002H3.8999V22.0002H4.2999C4.40599 22.0002 4.50773 21.9581 4.58275 21.883C4.65776 21.808 4.6999 21.7063 4.6999 21.6002",
    fill: "white"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 22.0002H6.29951V21.2002H5.89951C5.79342 21.2002 5.69168 21.2423 5.61666 21.3174C5.54165 21.3924 5.49951 21.4941 5.49951 21.6002",
    fill: "white"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 21.2002H6.29932V22.0002H7.09932V21.2002Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 21.2002H7.09961V22.0002H7.89961V21.2002Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 21.2002H7.89941V22.0002H8.69941V21.2002Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 21.2002H8.69971V22.0002H9.49971V21.2002Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 21.2002H9.49951V22.0002H9.89951C10.0056 22.0002 10.1073 21.9581 10.1824 21.883C10.2574 21.808 10.2995 21.7063 10.2995 21.6002",
    fill: "white"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 21.2002H11.0996V22.0002H11.8996V21.2002Z",
    fill: "white"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 21.2002H11.8994V22.0002H12.6994V21.2002Z",
    fill: "white"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 22.0002V21.2002H13.8995C13.7934 21.2002 13.6917 21.2423 13.6167 21.3174C13.5417 21.3924 13.4995 21.4941 13.4995 21.6002C13.4995 21.7063 13.5417 21.808 13.6167 21.883C13.6917 21.9581 13.7934 22.0002 13.8995 22.0002",
    fill: "white"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 21.2002H14.2993V22.0002H15.0993V21.2002Z",
    fill: "white"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 21.2002H15.0996V22.0002H15.4996C15.6057 22.0002 15.7074 21.9581 15.7825 21.883C15.8575 21.808 15.8996 21.7063 15.8996 21.6002",
    fill: "white"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 22.0002V21.2002H25.4995V21.6002C25.4995 21.7063 25.5417 21.808 25.6167 21.883C25.6917 21.9581 25.7934 22.0002 25.8995 22.0002",
    fill: "white"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 21.2002H26.2998V22.0002H26.6998C26.8059 22.0002 26.9076 21.9581 26.9826 21.883C27.0577 21.808 27.0998 21.7063 27.0998 21.6002",
    fill: "white"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6999 22.0002V21.2002H27.8999V21.6002C27.8999 21.7063 27.942 21.808 28.0171 21.883C28.0921 21.9581 28.1938 22.0002 28.2999 22.0002",
    fill: "white"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 21.2002V22.0002H29.4997V21.6002C29.4997 21.4941 29.4576 21.3924 29.3825 21.3174C29.3075 21.2423 29.2058 21.2002 29.0997 21.2002",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 22.0002V21.2002H30.2998V21.6002C30.2998 21.7063 30.3419 21.808 30.417 21.883C30.492 21.9581 30.5937 22.0002 30.6998 22.0002",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 21.2002H31.0996V22.0002H31.8996V21.2002Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 21.2002H31.8994V22.0002H32.6994V21.2002Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 21.2002H32.6997V22.0002H33.4997V21.2002Z",
    fill: "white"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 21.2002H33.4995V22.0002H34.2995V21.2002Z",
    fill: "white"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 21.2002H34.2993V22.0002H35.0993V21.2002Z",
    fill: "white"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 21.2002H35.0996V22.0002H35.4996C35.6057 22.0002 35.7074 21.9581 35.7825 21.883C35.8575 21.808 35.8996 21.7063 35.8996 21.6002",
    fill: "white"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 21.2002H38.2993V22.0002H39.0993V21.2002Z",
    fill: "white"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 22H3.09961V22.8H3.89961V22Z",
    fill: "white"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 22.8V22H5.09971C4.99362 22 4.89188 22.0421 4.81686 22.1172C4.74185 22.1922 4.69971 22.2939 4.69971 22.4C4.69971 22.5061 4.74185 22.6078 4.81686 22.6828C4.89188 22.7579 4.99362 22.8 5.09971 22.8",
    fill: "white"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 22H5.49951V22.8H6.29951V22Z",
    fill: "white"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 22H7.09961V22.8H7.89961V22Z",
    fill: "white"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 22H8.69971V22.8H9.49971V22Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 22.8H11.0993V22H10.6993C10.5932 22 10.4915 22.0421 10.4165 22.1172C10.3415 22.1922 10.2993 22.2939 10.2993 22.4",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 22H11.0996V22.8H11.8996V22Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 22H11.8999V22.8H12.2999C12.406 22.8 12.5077 22.7579 12.5827 22.6828C12.6578 22.6078 12.6999 22.5061 12.6999 22.4",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 22H14.2993V22.8H15.0993V22Z",
    fill: "white"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 22.8H16.6994V22.4C16.6994 22.2939 16.6573 22.1922 16.5823 22.1172C16.5072 22.0421 16.4055 22 16.2994 22C16.1933 22 16.0916 22.0421 16.0166 22.1172C15.9416 22.1922 15.8994 22.2939 15.8994 22.4",
    fill: "white"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 22.8H27.8996V22.4C27.8996 22.2939 27.8575 22.1922 27.7824 22.1172C27.7074 22.0421 27.6057 22 27.4996 22C27.3935 22 27.2918 22.0421 27.2168 22.1172C27.1417 22.1922 27.0996 22.2939 27.0996 22.4",
    fill: "white"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 22H28.6997V22.4C28.6997 22.5061 28.7418 22.6078 28.8169 22.6828C28.8919 22.7579 28.9936 22.8 29.0997 22.8C29.2058 22.8 29.3075 22.7579 29.3826 22.6828C29.4576 22.6078 29.4997 22.5061 29.4997 22.4",
    fill: "white"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 22.8V22H31.0996V22.4C31.0996 22.5061 31.1418 22.6078 31.2168 22.6828C31.2918 22.7579 31.3935 22.8 31.4996 22.8",
    fill: "white"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 22H31.8994V22.8H32.6994V22Z",
    fill: "white"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 22H32.6997V22.8H33.0997C33.2058 22.8 33.3075 22.7579 33.3826 22.6828C33.4576 22.6078 33.4997 22.5061 33.4997 22.4",
    fill: "white"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2994 22.8C36.5203 22.8 36.6994 22.6209 36.6994 22.4C36.6994 22.1791 36.5203 22 36.2994 22C36.0785 22 35.8994 22.1791 35.8994 22.4C35.8994 22.6209 36.0785 22.8 36.2994 22.8Z",
    fill: "white"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0998 22H38.2998V22.4C38.2998 22.5061 38.3419 22.6078 38.417 22.6828C38.492 22.7579 38.5937 22.8 38.6998 22.8C38.8059 22.8 38.9076 22.7579 38.9826 22.6828C39.0577 22.6078 39.0998 22.5061 39.0998 22.4",
    fill: "white"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 23.6003V22.8003H3.09961V23.2003C3.09961 23.3064 3.14175 23.4081 3.21677 23.4831C3.29178 23.5582 3.39352 23.6003 3.49961 23.6003",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 22.7998V23.5998H4.29941C4.4055 23.5998 4.50724 23.5577 4.58225 23.4826C4.65727 23.4076 4.69941 23.3059 4.69941 23.1998C4.69941 23.0937 4.65727 22.992 4.58225 22.917C4.50724 22.8419 4.4055 22.7998 4.29941 22.7998",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 22.7998H5.49951V23.5998H6.29951V22.7998Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 22.7998H7.09961V23.5998H7.89961V22.7998Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 22.7998H7.89941V23.5998H8.69941V22.7998Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 22.7998H8.69971V23.5998H9.09971C9.20579 23.5998 9.30754 23.5577 9.38255 23.4826C9.45756 23.4076 9.49971 23.3059 9.49971 23.1998",
    fill: "white"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 23.6003V22.8003H10.2998V23.2003C10.2998 23.3064 10.342 23.4081 10.417 23.4831C10.492 23.5582 10.5937 23.6003 10.6998 23.6003",
    fill: "white"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 22.7998H11.0996V23.5998H11.4996C11.6057 23.5998 11.7074 23.5577 11.7825 23.4826C11.8575 23.4076 11.8996 23.3059 11.8996 23.1998",
    fill: "white"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 23.6003V22.8003H13.0997C12.9936 22.8003 12.8919 22.8424 12.8169 22.9175C12.7418 22.9925 12.6997 23.0942 12.6997 23.2003C12.6997 23.3064 12.7418 23.4081 12.8169 23.4831C12.8919 23.5582 12.9936 23.6003 13.0997 23.6003",
    fill: "white"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 22.7998H13.4995V23.5998H14.2995V22.7998Z",
    fill: "white"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0993 22.7998H14.2993V23.5998H15.0993V22.7998Z",
    fill: "white"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 22.7998H15.8994V23.5998H16.6994V22.7998Z",
    fill: "white"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 22.7998V23.5998H17.0997C17.2058 23.5998 17.3075 23.5577 17.3825 23.4826C17.4576 23.4076 17.4997 23.3059 17.4997 23.1998C17.4997 23.0937 17.4576 22.992 17.3825 22.917C17.3075 22.8419 17.2058 22.7998 17.0997 22.7998",
    fill: "white"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 23.6003H25.4997V22.8003H25.0997C24.9936 22.8003 24.8919 22.8424 24.8169 22.9175C24.7418 22.9925 24.6997 23.0942 24.6997 23.2003",
    fill: "white"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 22.7998H25.4995V23.5998H26.2995V22.7998Z",
    fill: "white"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 22.7998H26.2993V23.5998H27.0993V22.7998Z",
    fill: "white"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 22.7998H27.0996V23.5998H27.8996V22.7998Z",
    fill: "white"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 22.7998V23.5998H28.2994C28.4055 23.5998 28.5072 23.5577 28.5823 23.4826C28.6573 23.4076 28.6994 23.3059 28.6994 23.1998C28.6994 23.0937 28.6573 22.992 28.5823 22.917C28.5072 22.8419 28.4055 22.7998 28.2994 22.7998",
    fill: "white"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6993 23.5998C30.9202 23.5998 31.0993 23.4207 31.0993 23.1998C31.0993 22.9789 30.9202 22.7998 30.6993 22.7998C30.4784 22.7998 30.2993 22.9789 30.2993 23.1998C30.2993 23.4207 30.4784 23.5998 30.6993 23.5998Z",
    fill: "white"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6993 23.5998C34.9202 23.5998 35.0993 23.4207 35.0993 23.1998C35.0993 22.9789 34.9202 22.7998 34.6993 22.7998C34.4784 22.7998 34.2993 22.9789 34.2993 23.1998C34.2993 23.4207 34.4784 23.5998 34.6993 23.5998Z",
    fill: "white"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 23.6003H38.2995V23.2003C38.2995 23.0942 38.2574 22.9925 38.1824 22.9175C38.1073 22.8424 38.0056 22.8003 37.8995 22.8003C37.7934 22.8003 37.6917 22.8424 37.6167 22.9175C37.5416 22.9925 37.4995 23.0942 37.4995 23.2003",
    fill: "white"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 23.6001H5.49951V24.0001C5.49951 24.1062 5.54165 24.2079 5.61667 24.2829C5.69168 24.358 5.79343 24.4001 5.89951 24.4001C6.0056 24.4001 6.10734 24.358 6.18235 24.2829C6.25737 24.2079 6.29951 24.1062 6.29951 24.0001",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 23.6001H7.09961V24.4001H7.89961V23.6001Z",
    fill: "white"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 24.4001V23.6001H13.4995V24.0001C13.4995 24.1062 13.5417 24.2079 13.6167 24.2829C13.6917 24.358 13.7934 24.4001 13.8995 24.4001",
    fill: "white"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0998 23.6001H14.2998V24.4001H14.6998C14.8059 24.4001 14.9076 24.358 14.9826 24.2829C15.0577 24.2079 15.0998 24.1062 15.0998 24.0001",
    fill: "white"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 23.6001H15.8994V24.4001H16.6994V23.6001Z",
    fill: "white"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8995 24.4001C18.1204 24.4001 18.2995 24.221 18.2995 24.0001C18.2995 23.7792 18.1204 23.6001 17.8995 23.6001C17.6786 23.6001 17.4995 23.7792 17.4995 24.0001C17.4995 24.221 17.6786 24.4001 17.8995 24.4001Z",
    fill: "white"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 24.4001C19.7205 24.4001 19.8996 24.221 19.8996 24.0001C19.8996 23.7792 19.7205 23.6001 19.4996 23.6001C19.2787 23.6001 19.0996 23.7792 19.0996 24.0001C19.0996 24.221 19.2787 24.4001 19.4996 24.4001Z",
    fill: "white"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6997 24.4001H21.4997V24.0001C21.4997 23.894 21.4576 23.7923 21.3825 23.7173C21.3075 23.6422 21.2058 23.6001 21.0997 23.6001C20.9936 23.6001 20.8919 23.6422 20.8169 23.7173C20.7418 23.7923 20.6997 23.894 20.6997 24.0001",
    fill: "white"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 23.6001H24.6997V24.0001C24.6997 24.1062 24.7418 24.2079 24.8169 24.2829C24.8919 24.358 24.9936 24.4001 25.0997 24.4001C25.2058 24.4001 25.3075 24.358 25.3826 24.2829C25.4576 24.2079 25.4997 24.1062 25.4997 24.0001",
    fill: "white"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 23.6001H26.2993V24.4001H27.0993V23.6001Z",
    fill: "white"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 23.6001H27.0996V24.4001H27.4996C27.6057 24.4001 27.7074 24.358 27.7825 24.2829C27.8575 24.2079 27.8996 24.1062 27.8996 24.0001",
    fill: "white"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 24.4001V23.6001H29.0997C28.9936 23.6001 28.8919 23.6422 28.8169 23.7173C28.7418 23.7923 28.6997 23.894 28.6997 24.0001C28.6997 24.1062 28.7418 24.2079 28.8169 24.2829C28.8919 24.358 28.9936 24.4001 29.0997 24.4001",
    fill: "white"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 23.6001V24.4001H30.2995V24.0001C30.2995 23.894 30.2574 23.7923 30.1824 23.7173C30.1073 23.6422 30.0056 23.6001 29.8995 23.6001",
    fill: "white"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2994 24.4001C32.5203 24.4001 32.6994 24.221 32.6994 24.0001C32.6994 23.7792 32.5203 23.6001 32.2994 23.6001C32.0785 23.6001 31.8994 23.7792 31.8994 24.0001C31.8994 24.221 32.0785 24.4001 32.2994 24.4001Z",
    fill: "white"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 24.4001H35.8996V23.6001H35.4996C35.3935 23.6001 35.2918 23.6422 35.2168 23.7173C35.1417 23.7923 35.0996 23.894 35.0996 24.0001",
    fill: "white"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 23.6001V24.4001H36.6994V24.0001C36.6994 23.894 36.6573 23.7923 36.5823 23.7173C36.5072 23.6422 36.4055 23.6001 36.2994 23.6001",
    fill: "white"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 24.4001V23.6001H37.4995V24.0001C37.4995 24.1062 37.5417 24.2079 37.6167 24.2829C37.6917 24.358 37.7934 24.4001 37.8995 24.4001",
    fill: "white"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 23.6001V24.4001H39.0993V24.0001C39.0993 23.894 39.0572 23.7923 38.9822 23.7173C38.9071 23.6422 38.8054 23.6001 38.6993 23.6001",
    fill: "white"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89941 25.2004H4.69941V24.4004H4.29941C4.19332 24.4004 4.09158 24.4425 4.01657 24.5176C3.94155 24.5926 3.89941 24.6943 3.89941 24.8004",
    fill: "white"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69971 24.3999V25.1999H5.49971V24.7999C5.49971 24.6938 5.45757 24.5921 5.38255 24.5171C5.30754 24.442 5.2058 24.3999 5.09971 24.3999",
    fill: "white"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 24.3999H7.09961V25.1999H7.89961V24.3999Z",
    fill: "white"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 24.3999H7.89941V25.1999H8.69941V24.3999Z",
    fill: "white"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 24.3999H8.69971V25.1999H9.49971V24.3999Z",
    fill: "white"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 24.3999H9.49951V25.1999H10.2995V24.3999Z",
    fill: "white"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 24.3999V25.1999H11.0993V24.7999C11.0993 24.6938 11.0572 24.5921 10.9822 24.5171C10.9071 24.442 10.8054 24.3999 10.6993 24.3999",
    fill: "white"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 25.2004H12.6994V24.8004C12.6994 24.6943 12.6573 24.5926 12.5823 24.5176C12.5072 24.4425 12.4055 24.4004 12.2994 24.4004C12.1933 24.4004 12.0916 24.4425 12.0166 24.5176C11.9416 24.5926 11.8994 24.6943 11.8994 24.8004",
    fill: "white"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 24.3999H15.8994V25.1999H16.6994V24.3999Z",
    fill: "white"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 24.3999V25.1999H17.0997C17.2058 25.1999 17.3075 25.1578 17.3825 25.0827C17.4576 25.0077 17.4997 24.906 17.4997 24.7999C17.4997 24.6938 17.4576 24.5921 17.3825 24.5171C17.3075 24.442 17.2058 24.3999 17.0997 24.3999",
    fill: "white"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 24.3999H20.6997V25.1999H21.4997V24.3999Z",
    fill: "white"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2993 25.2004H23.0993V24.8004C23.0993 24.6943 23.0572 24.5926 22.9822 24.5176C22.9071 24.4425 22.8054 24.4004 22.6993 24.4004C22.5932 24.4004 22.4915 24.4425 22.4165 24.5176C22.3415 24.5926 22.2993 24.6943 22.2993 24.8004",
    fill: "white"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8994 25.2004H24.6994V24.8004C24.6994 24.6943 24.6573 24.5926 24.5823 24.5176C24.5072 24.4425 24.4055 24.4004 24.2994 24.4004C24.1933 24.4004 24.0916 24.4425 24.0166 24.5176C23.9416 24.5926 23.8994 24.6943 23.8994 24.8004",
    fill: "white"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 24.3999H26.2998V24.7999C26.2998 24.906 26.3419 25.0077 26.417 25.0827C26.492 25.1578 26.5937 25.1999 26.6998 25.1999C26.8059 25.1999 26.9076 25.1578 26.9826 25.0827C27.0577 25.0077 27.0998 24.906 27.0998 24.7999",
    fill: "white"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2994 25.1999C28.5203 25.1999 28.6994 25.0208 28.6994 24.7999C28.6994 24.579 28.5203 24.3999 28.2994 24.3999C28.0785 24.3999 27.8994 24.579 27.8994 24.7999C27.8994 25.0208 28.0785 25.1999 28.2994 25.1999Z",
    fill: "white"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 24.3999H29.4995V25.1999H30.2995V24.3999Z",
    fill: "white"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 24.3999H30.2993V25.1999H31.0993V24.3999Z",
    fill: "white"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 24.3999V25.1999H31.8996V24.7999C31.8996 24.6938 31.8575 24.5921 31.7824 24.5171C31.7074 24.442 31.6057 24.3999 31.4996 24.3999",
    fill: "white"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 25.2004V24.4004H33.8995C33.7934 24.4004 33.6917 24.4425 33.6167 24.5176C33.5417 24.5926 33.4995 24.6943 33.4995 24.8004C33.4995 24.9065 33.5417 25.0082 33.6167 25.0832C33.6917 25.1583 33.7934 25.2004 33.8995 25.2004",
    fill: "white"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 24.3999H34.2993V25.1999H35.0993V24.3999Z",
    fill: "white"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 24.3999H35.0996V25.1999H35.8996V24.3999Z",
    fill: "white"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 24.3999H35.8994V25.1999H36.6994V24.3999Z",
    fill: "white"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 24.3999V25.1999H37.4997V24.7999C37.4997 24.6938 37.4576 24.5921 37.3825 24.5171C37.3075 24.442 37.2058 24.3999 37.0997 24.3999",
    fill: "white"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 24.3999H38.2993V25.1999H39.0993V24.3999Z",
    fill: "white"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M3.09961 26.0002H3.89961V25.2002H3.49961C3.39353 25.2002 3.29179 25.2423 3.21677 25.3174C3.14176 25.3924 3.09961 25.4941 3.09961 25.6002",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 25.2002H3.89941V26.0002H4.69941V25.2002Z",
    fill: "white"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 25.2002H4.69971V26.0002H5.49971V25.2002Z",
    fill: "white"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49951 25.2002V26.0002H6.29951V25.6002C6.29951 25.4941 6.25736 25.3924 6.18235 25.3174C6.10733 25.2423 6.00559 25.2002 5.89951 25.2002",
    fill: "white"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 25.2002H7.09961V26.0002H7.89961V25.2002Z",
    fill: "white"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 25.2002H8.69971V26.0002H9.49971V25.2002Z",
    fill: "white"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 25.2002H10.2993V26.0002H11.0993V25.2002Z",
    fill: "white"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 25.2002H11.8994V26.0002H12.6994V25.2002Z",
    fill: "white"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 26.0002H14.2995V25.6002C14.2995 25.4941 14.2574 25.3924 14.1824 25.3174C14.1073 25.2423 14.0056 25.2002 13.8995 25.2002C13.7934 25.2002 13.6917 25.2423 13.6167 25.3174C13.5416 25.3924 13.4995 25.4941 13.4995 25.6002",
    fill: "white"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 26.0002H15.8996V25.2002H15.4996C15.3935 25.2002 15.2918 25.2423 15.2168 25.3174C15.1417 25.3924 15.0996 25.4941 15.0996 25.6002",
    fill: "white"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 25.2002H15.8999V26.0002H16.2999C16.406 26.0002 16.5077 25.9581 16.5827 25.883C16.6578 25.808 16.6999 25.7063 16.6999 25.6002",
    fill: "white"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 26.0002H18.2995V25.6002C18.2995 25.4941 18.2574 25.3924 18.1824 25.3174C18.1073 25.2423 18.0056 25.2002 17.8995 25.2002C17.7934 25.2002 17.6917 25.2423 17.6167 25.3174C17.5416 25.3924 17.4995 25.4941 17.4995 25.6002",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 25.2002H20.6997V26.0002H21.4997V25.2002Z",
    fill: "white"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 26.0002V25.2002H22.2998V25.6002C22.2998 25.7063 22.3419 25.808 22.417 25.883C22.492 25.9581 22.5937 26.0002 22.6998 26.0002",
    fill: "white"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 25.2002H23.0996V26.0002H23.8996V25.2002Z",
    fill: "white"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6994 25.2002H23.8994V26.0002H24.6994V25.2002Z",
    fill: "white"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6997 25.2002V26.0002H25.4997V25.6002C25.4997 25.4941 25.4576 25.3924 25.3825 25.3174C25.3075 25.2423 25.2058 25.2002 25.0997 25.2002",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4996 26.0002C27.7205 26.0002 27.8996 25.8211 27.8996 25.6002C27.8996 25.3793 27.7205 25.2002 27.4996 25.2002C27.2787 25.2002 27.0996 25.3793 27.0996 25.6002C27.0996 25.8211 27.2787 26.0002 27.4996 26.0002Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 26.0002V25.2002H29.0997C28.9936 25.2002 28.8919 25.2423 28.8169 25.3174C28.7418 25.3924 28.6997 25.4941 28.6997 25.6002C28.6997 25.7063 28.7418 25.808 28.8169 25.883C28.8919 25.9581 28.9936 26.0002 29.0997 26.0002",
    fill: "white"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 25.2002H29.4995V26.0002H30.2995V25.2002Z",
    fill: "white"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 25.2002H30.2993V26.0002H31.0993V25.2002Z",
    fill: "white"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 25.2002H31.0996V26.0002H31.8996V25.2002Z",
    fill: "white"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 25.2002H31.8994V26.0002H32.6994V25.2002Z",
    fill: "white"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 25.2002V26.0002H33.4997V25.6002C33.4997 25.4941 33.4576 25.3924 33.3825 25.3174C33.3075 25.2423 33.2058 25.2002 33.0997 25.2002",
    fill: "white"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 25.2002H35.0996V26.0002H35.8996V25.2002Z",
    fill: "white"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 25.2002H35.8994V26.0002H36.6994V25.2002Z",
    fill: "white"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 25.2002H36.6997V26.0002H37.4997V25.2002Z",
    fill: "white"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 25.2002H37.4995V26.0002H38.2995V25.2002Z",
    fill: "white"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 25.2002H38.2993V26.0002H39.0993V25.2002Z",
    fill: "white"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 26H3.09961V26.8H3.89961V26Z",
    fill: "white"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 26H3.89941V26.8H4.69941V26Z",
    fill: "white"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 26H5.49951V26.4C5.49951 26.5061 5.54165 26.6078 5.61667 26.6828C5.69168 26.7579 5.79343 26.8 5.89951 26.8C6.0056 26.8 6.10734 26.7579 6.18235 26.6828C6.25737 26.6078 6.29951 26.5061 6.29951 26.4",
    fill: "white"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 26H7.09961V26.8H7.89961V26Z",
    fill: "white"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69941 26H7.89941V26.8H8.69941V26Z",
    fill: "white"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 26H8.69971V26.8H9.49971V26Z",
    fill: "white"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 26.8V26H10.2998V26.4C10.2998 26.5061 10.342 26.6078 10.417 26.6828C10.492 26.7579 10.5937 26.8 10.6998 26.8",
    fill: "white"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 26H11.0996V26.8H11.8996V26Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6994 26H11.8994V26.8H12.6994V26Z",
    fill: "white"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 26H12.6997V26.8H13.4997V26Z",
    fill: "white"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 26H13.4995V26.8H14.2995V26Z",
    fill: "white"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 26H15.0996V26.8H15.8996V26Z",
    fill: "white"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 26H17.4995V26.4C17.4995 26.5061 17.5417 26.6078 17.6167 26.6828C17.6917 26.7579 17.7934 26.8 17.8995 26.8C18.0056 26.8 18.1073 26.7579 18.1824 26.6828C18.2574 26.6078 18.2995 26.5061 18.2995 26.4",
    fill: "white"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4996 26.8C19.7205 26.8 19.8996 26.6209 19.8996 26.4C19.8996 26.1791 19.7205 26 19.4996 26C19.2787 26 19.0996 26.1791 19.0996 26.4C19.0996 26.6209 19.2787 26.8 19.4996 26.8Z",
    fill: "white"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 26H20.6997V26.4C20.6997 26.5061 20.7418 26.6078 20.8169 26.6828C20.8919 26.7579 20.9936 26.8 21.0997 26.8C21.2058 26.8 21.3075 26.7579 21.3826 26.6828C21.4576 26.6078 21.4997 26.5061 21.4997 26.4",
    fill: "white"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 26H23.0996V26.8H23.8996V26Z",
    fill: "white"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 26H24.6997V26.8H25.4997V26Z",
    fill: "white"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 26H25.4995V26.8H26.2995V26Z",
    fill: "white"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 26V26.8H27.0993V26.4C27.0993 26.2939 27.0572 26.1922 26.9822 26.1172C26.9071 26.0421 26.8054 26 26.6993 26",
    fill: "white"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 26H30.2993V26.8H31.0993V26Z",
    fill: "white"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 26H31.0996V26.8H31.8996V26Z",
    fill: "white"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 26H31.8994V26.8H32.6994V26Z",
    fill: "white"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 26H32.6997V26.8H33.4997V26Z",
    fill: "white"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4995 26V26.8H34.2995V26.4C34.2995 26.2939 34.2574 26.1922 34.1824 26.1172C34.1073 26.0421 34.0056 26 33.8995 26",
    fill: "white"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 26H35.0996V26.8H35.8996V26Z",
    fill: "white"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 26H36.6997V26.8H37.4997V26Z",
    fill: "white"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0998 26H38.2998V26.4C38.2998 26.5061 38.3419 26.6078 38.417 26.6828C38.492 26.7579 38.5937 26.8 38.6998 26.8C38.8059 26.8 38.9076 26.7579 38.9826 26.6828C39.0577 26.6078 39.0998 26.5061 39.0998 26.4",
    fill: "white"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 26.7998H3.09961V27.5998H3.89961V26.7998Z",
    fill: "white"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 26.7998H3.89941V27.5998H4.69941V26.7998Z",
    fill: "white"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 27.6003V26.8003H6.6998C6.59372 26.8003 6.49198 26.8424 6.41696 26.9175C6.34195 26.9925 6.2998 27.0942 6.2998 27.2003C6.2998 27.3064 6.34195 27.4081 6.41696 27.4831C6.49198 27.5582 6.59372 27.6003 6.6998 27.6003",
    fill: "white"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 26.7998H7.09961V27.5998H7.89961V26.7998Z",
    fill: "white"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 27.6003V26.8003H8.69971V27.2003C8.69971 27.3064 8.74185 27.4081 8.81686 27.4831C8.89188 27.5582 8.99362 27.6003 9.09971 27.6003",
    fill: "white"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 26.7998V27.5998H10.2995V27.1998C10.2995 27.0937 10.2574 26.992 10.1824 26.917C10.1073 26.8419 10.0056 26.7998 9.89951 26.7998",
    fill: "white"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 26.7998H12.6997V27.5998H13.4997V26.7998Z",
    fill: "white"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 26.7998H13.4995V27.5998H14.2995V26.7998Z",
    fill: "white"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 26.7998H15.0996V27.5998H15.8996V26.7998Z",
    fill: "white"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8994 27.6003H20.6994V27.2003C20.6994 27.0942 20.6573 26.9925 20.5823 26.9175C20.5072 26.8424 20.4055 26.8003 20.2994 26.8003C20.1933 26.8003 20.0916 26.8424 20.0166 26.9175C19.9416 26.9925 19.8994 27.0942 19.8994 27.2003",
    fill: "white"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8995 27.5998C22.1204 27.5998 22.2995 27.4207 22.2995 27.1998C22.2995 26.9789 22.1204 26.7998 21.8995 26.7998C21.6786 26.7998 21.4995 26.9789 21.4995 27.1998C21.4995 27.4207 21.6786 27.5998 21.8995 27.5998Z",
    fill: "white"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 27.6003V26.8003H23.0996V27.2003C23.0996 27.3064 23.1418 27.4081 23.2168 27.4831C23.2918 27.5582 23.3935 27.6003 23.4996 27.6003",
    fill: "white"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6994 26.7998H23.8994V27.5998H24.6994V26.7998Z",
    fill: "white"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 26.7998H24.6997V27.5998H25.4997V26.7998Z",
    fill: "white"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 26.7998H25.4995V27.5998H26.2995V26.7998Z",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 26.7998H26.2993V27.5998H27.0993V26.7998Z",
    fill: "white"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 26.7998V27.5998H27.8996V27.1998C27.8996 27.0937 27.8575 26.992 27.7824 26.917C27.7074 26.8419 27.6057 26.7998 27.4996 26.7998",
    fill: "white"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0997 27.5998C29.3206 27.5998 29.4997 27.4207 29.4997 27.1998C29.4997 26.9789 29.3206 26.7998 29.0997 26.7998C28.8788 26.7998 28.6997 26.9789 28.6997 27.1998C28.6997 27.4207 28.8788 27.5998 29.0997 27.5998Z",
    fill: "white"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 26.7998H30.2998V27.1998C30.2998 27.3059 30.3419 27.4076 30.417 27.4826C30.492 27.5577 30.5937 27.5998 30.6998 27.5998C30.8059 27.5998 30.9076 27.5577 30.9826 27.4826C31.0577 27.4076 31.0998 27.3059 31.0998 27.1998",
    fill: "white"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 26.7998H33.4995V27.5998H34.2995V26.7998Z",
    fill: "white"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 26.7998H35.0996V27.5998H35.8996V26.7998Z",
    fill: "white"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 26.7998H36.6997V27.5998H37.4997V26.7998Z",
    fill: "white"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 26.7998V27.5998H38.2995V27.1998C38.2995 27.0937 38.2574 26.992 38.1823 26.917C38.1073 26.8419 38.0056 26.7998 37.8995 26.7998",
    fill: "white"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89961 28.4001V27.6001H3.09961V28.0001C3.09961 28.1062 3.14175 28.2079 3.21677 28.2829C3.29178 28.358 3.39352 28.4001 3.49961 28.4001",
    fill: "white"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69941 27.6001H3.89941V28.4001H4.69941V27.6001Z",
    fill: "white"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89951 28.4001C6.12042 28.4001 6.29951 28.221 6.29951 28.0001C6.29951 27.7792 6.12042 27.6001 5.89951 27.6001C5.67859 27.6001 5.49951 27.7792 5.49951 28.0001C5.49951 28.221 5.67859 28.4001 5.89951 28.4001Z",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 27.6001H7.09961V28.4001H7.89961V27.6001Z",
    fill: "white"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89941 27.6001V28.4001H8.29941C8.4055 28.4001 8.50724 28.358 8.58225 28.2829C8.65727 28.2079 8.69941 28.1062 8.69941 28.0001C8.69941 27.894 8.65727 27.7923 8.58225 27.7173C8.50724 27.6422 8.4055 27.6001 8.29941 27.6001",
    fill: "white"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 27.6001H9.49951V28.4001H10.2995V27.6001Z",
    fill: "white"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 28.4001H11.8996V28.0001C11.8996 27.894 11.8575 27.7923 11.7824 27.7173C11.7074 27.6422 11.6057 27.6001 11.4996 27.6001C11.3935 27.6001 11.2918 27.6422 11.2168 27.7173C11.1417 27.7923 11.0996 27.894 11.0996 28.0001",
    fill: "white"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 28.4001V27.6001H12.6997V28.0001C12.6997 28.1062 12.7418 28.2079 12.8169 28.2829C12.8919 28.358 12.9936 28.4001 13.0997 28.4001",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 27.6001H13.4995V28.4001H14.2995V27.6001Z",
    fill: "white"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 28.4001V27.6001H15.0996V28.0001C15.0996 28.1062 15.1418 28.2079 15.2168 28.2829C15.2918 28.358 15.3935 28.4001 15.4996 28.4001",
    fill: "white"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 27.6001H15.8994V28.4001H16.6994V27.6001Z",
    fill: "white"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 27.6001V28.4001H17.0997C17.2058 28.4001 17.3075 28.358 17.3825 28.2829C17.4576 28.2079 17.4997 28.1062 17.4997 28.0001C17.4997 27.894 17.4576 27.7923 17.3825 27.7173C17.3075 27.6422 17.2058 27.6001 17.0997 27.6001",
    fill: "white"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 28.4001H19.8996V27.6001H19.4996C19.3935 27.6001 19.2918 27.6422 19.2168 27.7173C19.1417 27.7923 19.0996 27.894 19.0996 28.0001",
    fill: "white"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 27.6001H19.8999V28.4001H20.2999C20.406 28.4001 20.5077 28.358 20.5827 28.2829C20.6578 28.2079 20.6999 28.1062 20.6999 28.0001",
    fill: "white"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 27.6001H24.6997V28.4001H25.4997V27.6001Z",
    fill: "white"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 27.6001H25.4995V28.4001H26.2995V27.6001Z",
    fill: "white"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 27.6001H26.2993V28.4001H27.0993V27.6001Z",
    fill: "white"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 27.6001H27.0996V28.4001H27.8996V27.6001Z",
    fill: "white"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8995 28.4001C30.1204 28.4001 30.2995 28.221 30.2995 28.0001C30.2995 27.7792 30.1204 27.6001 29.8995 27.6001C29.6786 27.6001 29.4995 27.7792 29.4995 28.0001C29.4995 28.221 29.6786 28.4001 29.8995 28.4001Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 28.4001H31.8996V27.6001H31.4996C31.3935 27.6001 31.2918 27.6422 31.2168 27.7173C31.1417 27.7923 31.0996 27.894 31.0996 28.0001",
    fill: "white"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 27.6001V28.4001H32.2994C32.4055 28.4001 32.5072 28.358 32.5823 28.2829C32.6573 28.2079 32.6994 28.1062 32.6994 28.0001C32.6994 27.894 32.6573 27.7923 32.5823 27.7173C32.5072 27.6422 32.4055 27.6001 32.2994 27.6001",
    fill: "white"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 28.4001V27.6001H33.4995V28.0001C33.4995 28.1062 33.5417 28.2079 33.6167 28.2829C33.6917 28.358 33.7934 28.4001 33.8995 28.4001",
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 27.6001H34.2993V28.4001H35.0993V27.6001Z",
    fill: "white"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 27.6001H35.0996V28.4001H35.8996V27.6001Z",
    fill: "white"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 27.6001H35.8994V28.4001H36.6994V27.6001Z",
    fill: "white"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 27.6001H36.6997V28.4001H37.4997V27.6001Z",
    fill: "white"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 27.6001H37.4995V28.4001H37.8995C38.0056 28.4001 38.1073 28.358 38.1824 28.2829C38.2574 28.2079 38.2995 28.1062 38.2995 28.0001",
    fill: "white"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 28.3999H3.8999V28.7999C3.8999 28.906 3.94204 29.0077 4.01706 29.0827C4.09207 29.1578 4.19382 29.1999 4.2999 29.1999C4.40599 29.1999 4.50773 29.1578 4.58275 29.0827C4.65776 29.0077 4.6999 28.906 4.6999 28.7999",
    fill: "white"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29932 29.2004H7.09932V28.4004H6.69932C6.59324 28.4004 6.49149 28.4425 6.41648 28.5176C6.34146 28.5926 6.29932 28.6943 6.29932 28.8004",
    fill: "white"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89961 28.3999H7.09961V29.1999H7.49961C7.6057 29.1999 7.70744 29.1578 7.78245 29.0827C7.85747 29.0077 7.89961 28.906 7.89961 28.7999",
    fill: "white"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49971 29.2004V28.4004H9.09971C8.99362 28.4004 8.89188 28.4425 8.81686 28.5176C8.74185 28.5926 8.69971 28.6943 8.69971 28.8004C8.69971 28.9065 8.74185 29.0082 8.81686 29.0832C8.89188 29.1583 8.99362 29.2004 9.09971 29.2004",
    fill: "white"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 28.3999H9.49951V29.1999H9.89951C10.0056 29.1999 10.1073 29.1578 10.1824 29.0827C10.2574 29.0077 10.2995 28.906 10.2995 28.7999",
    fill: "white"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 28.3999H11.0996V29.1999H11.8996V28.3999Z",
    fill: "white"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 28.3999V29.1999H12.2994C12.4055 29.1999 12.5072 29.1578 12.5823 29.0827C12.6573 29.0077 12.6994 28.906 12.6994 28.7999C12.6994 28.6938 12.6573 28.5921 12.5823 28.5171C12.5072 28.442 12.4055 28.3999 12.2994 28.3999",
    fill: "white"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 29.2004V28.4004H13.4995V28.8004C13.4995 28.9065 13.5417 29.0082 13.6167 29.0832C13.6917 29.1583 13.7934 29.2004 13.8995 29.2004",
    fill: "white"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 28.3999V29.1999H14.6993C14.8054 29.1999 14.9071 29.1578 14.9822 29.0827C15.0572 29.0077 15.0993 28.906 15.0993 28.7999C15.0993 28.6938 15.0572 28.5921 14.9822 28.5171C14.9071 28.442 14.8054 28.3999 14.6993 28.3999",
    fill: "white"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 28.3999H19.0996V28.7999C19.0996 28.906 19.1418 29.0077 19.2168 29.0827C19.2918 29.1578 19.3935 29.1999 19.4996 29.1999C19.6057 29.1999 19.7074 29.1578 19.7825 29.0827C19.8575 29.0077 19.8996 28.906 19.8996 28.7999",
    fill: "white"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 29.2004H22.2995V28.8004C22.2995 28.6943 22.2574 28.5926 22.1824 28.5176C22.1073 28.4425 22.0056 28.4004 21.8995 28.4004C21.7934 28.4004 21.6917 28.4425 21.6167 28.5176C21.5416 28.5926 21.4995 28.6943 21.4995 28.8004",
    fill: "white"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 29.2004V28.4004H24.2999C24.1938 28.4004 24.0921 28.4425 24.0171 28.5176C23.942 28.5926 23.8999 28.6943 23.8999 28.8004C23.8999 28.9065 23.942 29.0082 24.0171 29.0832C24.0921 29.1583 24.1938 29.2004 24.2999 29.2004",
    fill: "white"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 28.3999H24.6997V29.1999H25.4997V28.3999Z",
    fill: "white"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 28.3999H27.0996V29.1999H27.8996V28.3999Z",
    fill: "white"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 28.3999H27.8994V29.1999H28.6994V28.3999Z",
    fill: "white"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 28.3999V29.1999H29.4997V28.7999C29.4997 28.6938 29.4576 28.5921 29.3825 28.5171C29.3075 28.442 29.2058 28.3999 29.0997 28.3999",
    fill: "white"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 29.2004H31.0993V28.4004H30.6993C30.5932 28.4004 30.4915 28.4425 30.4165 28.5176C30.3415 28.5926 30.2993 28.6943 30.2993 28.8004",
    fill: "white"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 28.3999H31.0996V29.1999H31.4996C31.6057 29.1999 31.7074 29.1578 31.7825 29.0827C31.8575 29.0077 31.8996 28.906 31.8996 28.7999",
    fill: "white"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 28.3999H34.2993V29.1999H35.0993V28.3999Z",
    fill: "white"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 28.3999H36.6997V28.7999C36.6997 28.906 36.7418 29.0077 36.8169 29.0827C36.8919 29.1578 36.9936 29.1999 37.0997 29.1999C37.2058 29.1999 37.3075 29.1578 37.3826 29.0827C37.4576 29.0077 37.4997 28.906 37.4997 28.7999",
    fill: "white"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 29.2002H6.29932V30.0002H7.09932V29.2002Z",
    fill: "white"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29941 30.0002C8.52032 30.0002 8.69941 29.8211 8.69941 29.6002C8.69941 29.3793 8.52032 29.2002 8.29941 29.2002C8.0785 29.2002 7.89941 29.3793 7.89941 29.6002C7.89941 29.8211 8.0785 30.0002 8.29941 30.0002Z",
    fill: "white"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2993 30.0002H11.0993V29.2002H10.6993C10.5932 29.2002 10.4915 29.2423 10.4165 29.3174C10.3415 29.3924 10.2993 29.4941 10.2993 29.6002",
    fill: "white"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 29.2002H11.0996V30.0002H11.8996V29.2002Z",
    fill: "white"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6997 30.0002H13.4997V29.6002C13.4997 29.4941 13.4576 29.3924 13.3825 29.3174C13.3075 29.2423 13.2058 29.2002 13.0997 29.2002C12.9936 29.2002 12.8919 29.2423 12.8169 29.3174C12.7418 29.3924 12.6997 29.4941 12.6997 29.6002",
    fill: "white"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0996 30.0002H15.8996V29.2002H15.4996C15.3935 29.2002 15.2918 29.2423 15.2168 29.3174C15.1417 29.3924 15.0996 29.4941 15.0996 29.6002",
    fill: "white"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 29.2002H15.8994V30.0002H16.6994V29.2002Z",
    fill: "white"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 29.2002V30.0002H17.4997V29.6002C17.4997 29.4941 17.4576 29.3924 17.3825 29.3174C17.3075 29.2423 17.2058 29.2002 17.0997 29.2002",
    fill: "white"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2994 30.0002C20.5203 30.0002 20.6994 29.8211 20.6994 29.6002C20.6994 29.3793 20.5203 29.2002 20.2994 29.2002C20.0785 29.2002 19.8994 29.3793 19.8994 29.6002C19.8994 29.8211 20.0785 30.0002 20.2994 30.0002Z",
    fill: "white"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 30.0002V29.2002H21.4995V29.6002C21.4995 29.7063 21.5417 29.808 21.6167 29.883C21.6917 29.9581 21.7934 30.0002 21.8995 30.0002",
    fill: "white"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2993 29.2002V30.0002H22.6993C22.8054 30.0002 22.9071 29.9581 22.9822 29.883C23.0572 29.808 23.0993 29.7063 23.0993 29.6002C23.0993 29.4941 23.0572 29.3924 22.9822 29.3174C22.9071 29.2423 22.8054 29.2002 22.6993 29.2002",
    fill: "white"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 29.2002H24.6997V30.0002H25.4997V29.2002Z",
    fill: "white"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 29.2002H25.4995V30.0002H26.2995V29.2002Z",
    fill: "white"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 29.2002H26.2993V30.0002H27.0993V29.2002Z",
    fill: "white"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 29.2002H27.0996V30.0002H27.8996V29.2002Z",
    fill: "white"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 29.2002H27.8994V30.0002H28.6994V29.2002Z",
    fill: "white"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 29.2002H28.6997V30.0002H29.4997V29.2002Z",
    fill: "white"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 29.2002H30.2993V30.0002H31.0993V29.2002Z",
    fill: "white"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8994 30.0002H32.6994V29.2002H32.2994C32.1933 29.2002 32.0916 29.2423 32.0166 29.3174C31.9416 29.3924 31.8994 29.4941 31.8994 29.6002",
    fill: "white"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 29.2002V30.0002H33.0997C33.2058 30.0002 33.3075 29.9581 33.3825 29.883C33.4576 29.808 33.4997 29.7063 33.4997 29.6002C33.4997 29.4941 33.4576 29.3924 33.3825 29.3174C33.3075 29.2423 33.2058 29.2002 33.0997 29.2002",
    fill: "white"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 29.2002H34.2993V30.0002H35.0993V29.2002Z",
    fill: "white"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 29.2002H35.0996V30.0002H35.8996V29.2002Z",
    fill: "white"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 29.2002V30.0002H36.2994C36.4055 30.0002 36.5072 29.9581 36.5823 29.883C36.6573 29.808 36.6994 29.7063 36.6994 29.6002C36.6994 29.4941 36.6573 29.3924 36.5823 29.3174C36.5072 29.2423 36.4055 29.2002 36.2994 29.2002",
    fill: "white"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6993 30.0002C38.9202 30.0002 39.0993 29.8211 39.0993 29.6002C39.0993 29.3793 38.9202 29.2002 38.6993 29.2002C38.4784 29.2002 38.2993 29.3793 38.2993 29.6002C38.2993 29.8211 38.4784 30.0002 38.6993 30.0002Z",
    fill: "white"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6999 30.8V30H4.2999C4.19382 30 4.09207 30.0421 4.01706 30.1172C3.94204 30.1922 3.8999 30.2939 3.8999 30.4C3.8999 30.5061 3.94204 30.6078 4.01706 30.6828C4.09207 30.7579 4.19382 30.8 4.2999 30.8",
    fill: "white"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49971 30H4.69971V30.8H5.49971V30Z",
    fill: "white"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 30H5.49951V30.8H6.29951V30Z",
    fill: "white"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09932 30H6.29932V30.8H7.09932V30Z",
    fill: "white"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 30H10.2993V30.8H11.0993V30Z",
    fill: "white"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 30H11.0996V30.8H11.4996C11.6057 30.8 11.7074 30.7579 11.7825 30.6828C11.8575 30.6078 11.8996 30.5061 11.8996 30.4",
    fill: "white"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 30H12.6997V30.8H13.4997V30Z",
    fill: "white"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 30V30.8H14.2995V30.4C14.2995 30.2939 14.2574 30.1922 14.1824 30.1172C14.1073 30.0421 14.0056 30 13.8995 30",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 30.8V30H15.0996V30.4C15.0996 30.5061 15.1418 30.6078 15.2168 30.6828C15.2918 30.7579 15.3935 30.8 15.4996 30.8",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 30H15.8994V30.8H16.6994V30Z",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 30H16.6997V30.8H17.0997C17.2058 30.8 17.3075 30.7579 17.3826 30.6828C17.4576 30.6078 17.4997 30.5061 17.4997 30.4",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 30.8H23.8996V30.4C23.8996 30.2939 23.8575 30.1922 23.7824 30.1172C23.7074 30.0421 23.6057 30 23.4996 30C23.3935 30 23.2918 30.0421 23.2168 30.1172C23.1417 30.1922 23.0996 30.2939 23.0996 30.4",
    fill: "white"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 30H24.6997V30.8H25.4997V30Z",
    fill: "white"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 30H25.4995V30.8H26.2995V30Z",
    fill: "white"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 30H27.8994V30.8H28.6994V30Z",
    fill: "white"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 30H28.6997V30.8H29.4997V30Z",
    fill: "white"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 30H30.2998V30.4C30.2998 30.5061 30.3419 30.6078 30.417 30.6828C30.492 30.7579 30.5937 30.8 30.6998 30.8C30.8059 30.8 30.9076 30.7579 30.9826 30.6828C31.0577 30.6078 31.0998 30.5061 31.0998 30.4",
    fill: "white"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 30H31.8994V30.8H32.6994V30Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 30H34.2993V30.8H35.0993V30Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0997 30.8C37.3206 30.8 37.4997 30.6209 37.4997 30.4C37.4997 30.1791 37.3206 30 37.0997 30C36.8788 30 36.6997 30.1791 36.6997 30.4C36.6997 30.6209 36.8788 30.8 37.0997 30.8Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49961 31.5998C3.72053 31.5998 3.89961 31.4207 3.89961 31.1998C3.89961 30.9789 3.72053 30.7998 3.49961 30.7998C3.2787 30.7998 3.09961 30.9789 3.09961 31.1998C3.09961 31.4207 3.2787 31.5998 3.49961 31.5998Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29951 31.6003V30.8003H5.49951V31.2003C5.49951 31.3064 5.54165 31.4081 5.61667 31.4831C5.69168 31.5582 5.79343 31.6003 5.89951 31.6003",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0998 30.7998H6.2998V31.5998H6.6998C6.80589 31.5998 6.90763 31.5577 6.98265 31.4826C7.05766 31.4076 7.0998 31.3059 7.0998 31.1998",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6999 31.6003V30.8003H8.2999C8.19382 30.8003 8.09207 30.8424 8.01706 30.9175C7.94205 30.9925 7.8999 31.0942 7.8999 31.2003C7.8999 31.3064 7.94205 31.4081 8.01706 31.4831C8.09207 31.5582 8.19382 31.6003 8.2999 31.6003",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69971 30.7998V31.5998H9.09971C9.2058 31.5998 9.30754 31.5577 9.38255 31.4826C9.45757 31.4076 9.49971 31.3059 9.49971 31.1998C9.49971 31.0937 9.45757 30.992 9.38255 30.917C9.30754 30.8419 9.2058 30.7998 9.09971 30.7998",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 30.7998H10.2993V31.5998H11.0993V30.7998Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 30.7998H12.6997V31.5998H13.4997V30.7998Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 30.7998H13.4995V31.5998H14.2995V30.7998Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 30.7998V31.5998H14.6993C14.8054 31.5998 14.9071 31.5577 14.9822 31.4826C15.0572 31.4076 15.0993 31.3059 15.0993 31.1998C15.0993 31.0937 15.0572 30.992 14.9822 30.917C14.9071 30.8419 14.8054 30.7998 14.6993 30.7998",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 31.6003H18.2995V31.2003C18.2995 31.0942 18.2574 30.9925 18.1824 30.9175C18.1073 30.8424 18.0056 30.8003 17.8995 30.8003C17.7934 30.8003 17.6917 30.8424 17.6167 30.9175C17.5416 30.9925 17.4995 31.0942 17.4995 31.2003",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0996 31.6003H19.8996V30.8003H19.4996C19.3935 30.8003 19.2918 30.8424 19.2168 30.9175C19.1417 30.9925 19.0996 31.0942 19.0996 31.2003",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 30.7998H19.8994V31.5998H20.6994V30.7998Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 30.7998H20.6997V31.5998H21.4997V30.7998Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 30.7998H21.4995V31.5998H22.2995V30.7998Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 30.7998H22.2993V31.5998H23.0993V30.7998Z",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8996 30.7998H23.0996V31.5998H23.8996V30.7998Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6994 30.7998H23.8994V31.5998H24.6994V30.7998Z",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 30.7998H24.6997V31.5998H25.4997V30.7998Z",
    fill: "white"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 30.7998H25.4995V31.5998H25.8995C26.0056 31.5998 26.1073 31.5577 26.1824 31.4826C26.2574 31.4076 26.2995 31.3059 26.2995 31.1998",
    fill: "white"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 31.6003V30.8003H27.4996C27.3935 30.8003 27.2918 30.8424 27.2168 30.9175C27.1418 30.9925 27.0996 31.0942 27.0996 31.2003C27.0996 31.3064 27.1418 31.4081 27.2168 31.4831C27.2918 31.5582 27.3935 31.6003 27.4996 31.6003",
    fill: "white"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 30.7998H27.8994V31.5998H28.6994V30.7998Z",
    fill: "white"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 30.7998H28.6997V31.5998H29.4997V30.7998Z",
    fill: "white"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4995 30.7998V31.5998H30.2995V31.1998C30.2995 31.0937 30.2574 30.992 30.1824 30.917C30.1073 30.8419 30.0056 30.7998 29.8995 30.7998",
    fill: "white"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 31.6003H31.8996V30.8003H31.4996C31.3935 30.8003 31.2918 30.8424 31.2168 30.9175C31.1417 30.9925 31.0996 31.0942 31.0996 31.2003",
    fill: "white"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 30.7998H31.8994V31.5998H32.6994V30.7998Z",
    fill: "white"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 30.7998H32.6997V31.5998H33.4997V30.7998Z",
    fill: "white"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 30.7998H33.4995V31.5998H34.2995V30.7998Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 30.7998H34.2993V31.5998H35.0993V30.7998Z",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 30.7998H35.0996V31.5998H35.8996V30.7998Z",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 30.7998V31.5998H36.6994V31.1998C36.6994 31.0937 36.6573 30.992 36.5823 30.917C36.5072 30.8419 36.4055 30.7998 36.2994 30.7998",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 31.6003V30.8003H37.8995C37.7934 30.8003 37.6917 30.8424 37.6167 30.9175C37.5417 30.9925 37.4995 31.0942 37.4995 31.2003C37.4995 31.3064 37.5417 31.4081 37.6167 31.4831C37.6917 31.5582 37.7934 31.6003 37.8995 31.6003",
    fill: "white"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 30.7998V31.5998H38.6993C38.8054 31.5998 38.9071 31.5577 38.9822 31.4826C39.0572 31.4076 39.0993 31.3059 39.0993 31.1998C39.0993 31.0937 39.0572 30.992 38.9822 30.917C38.9071 30.8419 38.8054 30.7998 38.6993 30.7998",
    fill: "white"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 32.4001H10.2995V31.6001H9.89951C9.79342 31.6001 9.69168 31.6422 9.61666 31.7173C9.54165 31.7923 9.49951 31.894 9.49951 32.0001",
    fill: "white"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0998 31.6001H10.2998V32.4001H10.6998C10.8059 32.4001 10.9076 32.358 10.9826 32.2829C11.0577 32.2079 11.0998 32.1062 11.0998 32.0001",
    fill: "white"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4997 31.6001H12.6997V32.0001C12.6997 32.1062 12.7418 32.2079 12.8169 32.2829C12.8919 32.358 12.9936 32.4001 13.0997 32.4001C13.2058 32.4001 13.3075 32.358 13.3826 32.2829C13.4576 32.2079 13.4997 32.1062 13.4997 32.0001",
    fill: "white"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2994 32.4001C16.5203 32.4001 16.6994 32.221 16.6994 32.0001C16.6994 31.7792 16.5203 31.6001 16.2994 31.6001C16.0785 31.6001 15.8994 31.7792 15.8994 32.0001C15.8994 32.221 16.0785 32.4001 16.2994 32.4001Z",
    fill: "white"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 32.4001V31.6001H17.4995V32.0001C17.4995 32.1062 17.5417 32.2079 17.6167 32.2829C17.6917 32.358 17.7934 32.4001 17.8995 32.4001",
    fill: "white"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 31.6001H18.2993V32.4001H19.0993V31.6001Z",
    fill: "white"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 31.6001H19.0996V32.4001H19.8996V31.6001Z",
    fill: "white"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 31.6001H22.2993V32.4001H23.0993V31.6001Z",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 32.4001V31.6001H23.8999V32.0001C23.8999 32.1062 23.942 32.2079 24.0171 32.2829C24.0921 32.358 24.1938 32.4001 24.2999 32.4001",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 31.6001H24.6997V32.4001H25.0997C25.2058 32.4001 25.3075 32.358 25.3826 32.2829C25.4576 32.2079 25.4997 32.1062 25.4997 32.0001",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6993 32.4001C26.9202 32.4001 27.0993 32.221 27.0993 32.0001C27.0993 31.7792 26.9202 31.6001 26.6993 31.6001C26.4784 31.6001 26.2993 31.7792 26.2993 32.0001C26.2993 32.221 26.4784 32.4001 26.6993 32.4001Z",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 32.4001V31.6001H28.6997V32.0001C28.6997 32.1062 28.7418 32.2079 28.8169 32.2829C28.8919 32.358 28.9936 32.4001 29.0997 32.4001",
    fill: "white"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 31.6001H29.4995V32.4001H29.8995C30.0056 32.4001 30.1073 32.358 30.1824 32.2829C30.2574 32.2079 30.2995 32.1062 30.2995 32.0001",
    fill: "white"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 31.6001H31.0996V32.4001H31.8996V31.6001Z",
    fill: "white"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 31.6001H31.8994V32.4001H32.6994V31.6001Z",
    fill: "white"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 31.6001H35.0996V32.4001H35.8996V31.6001Z",
    fill: "white"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 31.6001H35.8994V32.4001H36.6994V31.6001Z",
    fill: "white"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 31.6001V32.4001H37.4997V32.0001C37.4997 31.894 37.4576 31.7923 37.3825 31.7173C37.3075 31.6422 37.2058 31.6001 37.0997 31.6001",
    fill: "white"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 32.3999H9.49951V32.7999C9.49951 32.906 9.54165 33.0077 9.61667 33.0827C9.69168 33.1578 9.79343 33.1999 9.89951 33.1999C10.0056 33.1999 10.1073 33.1578 10.1824 33.0827C10.2574 33.0077 10.2995 32.906 10.2995 32.7999",
    fill: "white"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 33.2004H11.8996V32.4004H11.4996C11.3935 32.4004 11.2918 32.4425 11.2168 32.5176C11.1417 32.5926 11.0996 32.6943 11.0996 32.8004",
    fill: "white"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 32.3999V33.1999H12.6994V32.7999C12.6994 32.6938 12.6573 32.5921 12.5823 32.5171C12.5072 32.442 12.4055 32.3999 12.2994 32.3999",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 33.2004V32.4004H13.8995C13.7934 32.4004 13.6917 32.4425 13.6167 32.5176C13.5417 32.5926 13.4995 32.6943 13.4995 32.8004C13.4995 32.9065 13.5417 33.0082 13.6167 33.0832C13.6917 33.1583 13.7934 33.2004 13.8995 33.2004",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 32.3999V33.1999H14.6993C14.8054 33.1999 14.9071 33.1578 14.9822 33.0827C15.0572 33.0077 15.0993 32.906 15.0993 32.7999C15.0993 32.6938 15.0572 32.5921 14.9822 32.5171C14.9071 32.442 14.8054 32.3999 14.6993 32.3999",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 33.2004H17.4997V32.8004C17.4997 32.6943 17.4576 32.5926 17.3825 32.5176C17.3075 32.4425 17.2058 32.4004 17.0997 32.4004C16.9936 32.4004 16.8919 32.4425 16.8169 32.5176C16.7418 32.5926 16.6997 32.6943 16.6997 32.8004",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 32.3999H19.0996V33.1999H19.8996V32.3999Z",
    fill: "white"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0997 33.1999C21.3206 33.1999 21.4997 33.0208 21.4997 32.7999C21.4997 32.579 21.3206 32.3999 21.0997 32.3999C20.8788 32.3999 20.6997 32.579 20.6997 32.7999C20.6997 33.0208 20.8788 33.1999 21.0997 33.1999Z",
    fill: "white"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 32.3999H22.2993V33.1999H23.0993V32.3999Z",
    fill: "white"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 33.2004V32.4004H27.4996C27.3935 32.4004 27.2918 32.4425 27.2168 32.5176C27.1418 32.5926 27.0996 32.6943 27.0996 32.8004C27.0996 32.9065 27.1418 33.0082 27.2168 33.0832C27.2918 33.1583 27.3935 33.2004 27.4996 33.2004",
    fill: "white"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8994 32.3999V33.1999H28.2994C28.4055 33.1999 28.5072 33.1578 28.5823 33.0827C28.6573 33.0077 28.6994 32.906 28.6994 32.7999C28.6994 32.6938 28.6573 32.5921 28.5823 32.5171C28.5072 32.442 28.4055 32.3999 28.2994 32.3999",
    fill: "white"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 33.2004H31.0993V32.4004H30.6993C30.5932 32.4004 30.4915 32.4425 30.4165 32.5176C30.3415 32.5926 30.2993 32.6943 30.2993 32.8004",
    fill: "white"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 32.3999H31.0996V33.1999H31.8996V32.3999Z",
    fill: "white"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 32.3999H31.8994V33.1999H32.6994V32.3999Z",
    fill: "white"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8995 33.1999C34.1204 33.1999 34.2995 33.0208 34.2995 32.7999C34.2995 32.579 34.1204 32.3999 33.8995 32.3999C33.6786 32.3999 33.4995 32.579 33.4995 32.7999C33.4995 33.0208 33.6786 33.1999 33.8995 33.1999Z",
    fill: "white"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 32.3999H35.0996V33.1999H35.8996V32.3999Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6994 32.3999H35.8994V33.1999H36.6994V32.3999Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 32.3999H36.6997V33.1999H37.4997V32.3999Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4995 32.3999V33.1999H37.8995C38.0056 33.1999 38.1073 33.1578 38.1823 33.0827C38.2574 33.0077 38.2995 32.906 38.2995 32.7999C38.2995 32.6938 38.2574 32.5921 38.1823 32.5171C38.1073 32.442 38.0056 32.3999 37.8995 32.3999",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 33.2002H11.0996V34.0002H11.8996V33.2002Z",
    fill: "white"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6999 33.2002H11.8999V34.0002H12.2999C12.406 34.0002 12.5077 33.9581 12.5827 33.883C12.6578 33.808 12.6999 33.7063 12.6999 33.6002",
    fill: "white"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8996 34.0002V33.2002H15.4996C15.3935 33.2002 15.2918 33.2423 15.2168 33.3174C15.1418 33.3924 15.0996 33.4941 15.0996 33.6002C15.0996 33.7063 15.1418 33.808 15.2168 33.883C15.2918 33.9581 15.3935 34.0002 15.4996 34.0002",
    fill: "white"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 33.2002H15.8994V34.0002H16.6994V33.2002Z",
    fill: "white"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 33.2002H16.6997V34.0002H17.4997V33.2002Z",
    fill: "white"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 33.2002V34.0002H17.8995C18.0056 34.0002 18.1073 33.9581 18.1824 33.883C18.2574 33.808 18.2995 33.7063 18.2995 33.6002C18.2995 33.4941 18.2574 33.3924 18.1824 33.3174C18.1073 33.2423 18.0056 33.2002 17.8995 33.2002",
    fill: "white"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 33.2002H19.0996V34.0002H19.8996V33.2002Z",
    fill: "white"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 33.2002H22.2993V34.0002H23.0993V33.2002Z",
    fill: "white"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6999 34.0002V33.2002H24.2999C24.1938 33.2002 24.0921 33.2423 24.0171 33.3174C23.942 33.3924 23.8999 33.4941 23.8999 33.6002C23.8999 33.7063 23.942 33.808 24.0171 33.883C24.0921 33.9581 24.1938 34.0002 24.2999 34.0002",
    fill: "white"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4997 33.2002H24.6997V34.0002H25.4997V33.2002Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 33.2002H25.4995V34.0002H26.2995V33.2002Z",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2993 33.2002V34.0002H27.0993V33.6002C27.0993 33.4941 27.0572 33.3924 26.9822 33.3174C26.9071 33.2423 26.8054 33.2002 26.6993 33.2002",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 33.2002H30.2998V33.6002C30.2998 33.7063 30.3419 33.808 30.417 33.883C30.492 33.9581 30.5937 34.0002 30.6998 34.0002C30.8059 34.0002 30.9076 33.9581 30.9826 33.883C31.0577 33.808 31.0998 33.7063 31.0998 33.6002",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 33.2002H31.8994V34.0002H32.6994V33.2002Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 33.2002H35.0996V34.0002H35.8996V33.2002Z",
    fill: "white"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 33.2002H36.6997V33.6002C36.6997 33.7063 36.7418 33.808 36.8169 33.883C36.8919 33.9581 36.9936 34.0002 37.0997 34.0002C37.2058 34.0002 37.3075 33.9581 37.3826 33.883C37.4576 33.808 37.4997 33.7063 37.4997 33.6002",
    fill: "white"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49951 34.8H10.2995V34.4C10.2995 34.2939 10.2574 34.1922 10.1824 34.1172C10.1073 34.0421 10.0056 34 9.89951 34C9.79342 34 9.69168 34.0421 9.61666 34.1172C9.54165 34.1922 9.49951 34.2939 9.49951 34.4",
    fill: "white"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 34H11.0996V34.8H11.8996V34Z",
    fill: "white"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8995 34.8C14.1204 34.8 14.2995 34.6209 14.2995 34.4C14.2995 34.1791 14.1204 34 13.8995 34C13.6786 34 13.4995 34.1791 13.4995 34.4C13.4995 34.6209 13.6786 34.8 13.8995 34.8Z",
    fill: "white"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 34H16.6997V34.8H17.4997V34Z",
    fill: "white"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2993 34.8H19.0993V34H18.6993C18.5932 34 18.4915 34.0421 18.4165 34.1172C18.3415 34.1922 18.2993 34.2939 18.2993 34.4",
    fill: "white"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 34H19.0996V34.8H19.8996V34Z",
    fill: "white"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 34H19.8994V34.8H20.6994V34Z",
    fill: "white"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 34H20.6997V34.8H21.4997V34Z",
    fill: "white"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 34H21.4995V34.8H22.2995V34Z",
    fill: "white"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 34H22.2998V34.8H22.6998C22.8059 34.8 22.9076 34.7579 22.9826 34.6828C23.0577 34.6078 23.0998 34.5061 23.0998 34.4",
    fill: "white"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0993 34H26.2993V34.8H27.0993V34Z",
    fill: "white"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6997 34.8H29.4997V34.4C29.4997 34.2939 29.4576 34.1922 29.3825 34.1172C29.3075 34.0421 29.2058 34 29.0997 34C28.9936 34 28.8919 34.0421 28.8169 34.1172C28.7418 34.1922 28.6997 34.2939 28.6997 34.4",
    fill: "white"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0996 34.8H31.8996V34H31.4996C31.3935 34 31.2918 34.0421 31.2168 34.1172C31.1417 34.1922 31.0996 34.2939 31.0996 34.4",
    fill: "white"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6994 34H31.8994V34.8H32.6994V34Z",
    fill: "white"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 34H32.6997V34.8H33.4997V34Z",
    fill: "white"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 34H33.4995V34.8H34.2995V34Z",
    fill: "white"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 34H34.2993V34.8H35.0993V34Z",
    fill: "white"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 34H35.0996V34.8H35.8996V34Z",
    fill: "white"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8994 34V34.8H36.6994V34.4C36.6994 34.2939 36.6573 34.1922 36.5823 34.1172C36.5072 34.0421 36.4055 34 36.2994 34",
    fill: "white"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2993 34.8H39.0993V34.4C39.0993 34.2939 39.0572 34.1922 38.9822 34.1172C38.9071 34.0421 38.8054 34 38.6993 34C38.5932 34 38.4915 34.0421 38.4165 34.1172C38.3415 34.1922 38.2993 34.2939 38.2993 34.4",
    fill: "white"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 34.7998H9.49951V35.1998C9.49951 35.3059 9.54166 35.4076 9.61667 35.4826C9.69169 35.5577 9.79343 35.5998 9.89951 35.5998C10.0056 35.5998 10.1073 35.5577 10.1824 35.4826C10.2574 35.4076 10.2995 35.3059 10.2995 35.1998",
    fill: "white"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 34.7998H11.0996V35.5998H11.8996V34.7998Z",
    fill: "white"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0997 35.5998C13.3206 35.5998 13.4997 35.4207 13.4997 35.1998C13.4997 34.9789 13.3206 34.7998 13.0997 34.7998C12.8788 34.7998 12.6997 34.9789 12.6997 35.1998C12.6997 35.4207 12.8788 35.5998 13.0997 35.5998Z",
    fill: "white"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6993 35.5998C14.9202 35.5998 15.0993 35.4207 15.0993 35.1998C15.0993 34.9789 14.9202 34.7998 14.6993 34.7998C14.4784 34.7998 14.2993 34.9789 14.2993 35.1998C14.2993 35.4207 14.4784 35.5998 14.6993 35.5998Z",
    fill: "white"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8994 35.6003H16.6994V34.8003H16.2994C16.1933 34.8003 16.0916 34.8424 16.0166 34.9175C15.9416 34.9925 15.8994 35.0942 15.8994 35.2003",
    fill: "white"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 34.7998H16.6997V35.5998H17.0997C17.2058 35.5998 17.3075 35.5577 17.3825 35.4826C17.4576 35.4076 17.4997 35.3059 17.4997 35.1998",
    fill: "white"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0998 34.7998H18.2998V35.1998C18.2998 35.3059 18.3419 35.4076 18.417 35.4826C18.492 35.5577 18.5937 35.5998 18.6998 35.5998C18.8059 35.5998 18.9076 35.5577 18.9826 35.4826C19.0577 35.4076 19.0998 35.3059 19.0998 35.1998",
    fill: "white"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 34.7998H21.4995V35.5998H22.2995V34.7998Z",
    fill: "white"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2995 35.6003V34.8003H25.8995C25.7934 34.8003 25.6917 34.8424 25.6167 34.9175C25.5417 34.9925 25.4995 35.0942 25.4995 35.2003C25.4995 35.3064 25.5417 35.4081 25.6167 35.4831C25.6917 35.5582 25.7934 35.6003 25.8995 35.6003",
    fill: "white"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 34.7998H26.2998V35.5998H26.6998C26.8059 35.5998 26.9076 35.5577 26.9826 35.4826C27.0577 35.4076 27.0998 35.3059 27.0998 35.1998",
    fill: "white"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 34.7998H28.6997V35.5998H29.4997V34.7998Z",
    fill: "white"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2993 35.6003H31.0993V34.8003H30.6993C30.5932 34.8003 30.4915 34.8424 30.4165 34.9175C30.3415 34.9925 30.2993 35.0942 30.2993 35.2003",
    fill: "white"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8996 34.7998H31.0996V35.5998H31.4996C31.6057 35.5998 31.7074 35.5577 31.7825 35.4826C31.8575 35.4076 31.8996 35.3059 31.8996 35.1998",
    fill: "white"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 35.6003V34.8003H33.4995V35.2003C33.4995 35.3064 33.5417 35.4081 33.6167 35.4831C33.6917 35.5582 33.7934 35.6003 33.8995 35.6003",
    fill: "white"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 34.7998H34.2993V35.5998H35.0993V34.7998Z",
    fill: "white"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 34.7998H35.0996V35.5998H35.8996V34.7998Z",
    fill: "white"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6999 34.7998H35.8999V35.5998H36.2999C36.406 35.5998 36.5077 35.5577 36.5827 35.4826C36.6578 35.4076 36.6999 35.3059 36.6999 35.1998",
    fill: "white"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 34.7998H38.2993V35.5998H39.0993V34.7998Z",
    fill: "white"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 35.6001H11.0996V36.4001H11.8996V35.6001Z",
    fill: "white"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8994 35.6001V36.4001H12.2994C12.4055 36.4001 12.5072 36.358 12.5823 36.2829C12.6573 36.2079 12.6994 36.1062 12.6994 36.0001C12.6994 35.894 12.6573 35.7923 12.5823 35.7173C12.5072 35.6422 12.4055 35.6001 12.2994 35.6001",
    fill: "white"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6994 35.6001H15.8994V36.4001H16.6994V35.6001Z",
    fill: "white"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4995 36.4001H18.2995V36.0001C18.2995 35.894 18.2574 35.7923 18.1823 35.7173C18.1073 35.6422 18.0056 35.6001 17.8995 35.6001C17.7934 35.6001 17.6917 35.6422 17.6167 35.7173C17.5417 35.7923 17.4995 35.894 17.4995 36.0001",
    fill: "white"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8994 36.4001H20.6994V35.6001H20.2994C20.1933 35.6001 20.0916 35.6422 20.0166 35.7173C19.9416 35.7923 19.8994 35.894 19.8994 36.0001",
    fill: "white"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 35.6001H20.6997V36.4001H21.4997V35.6001Z",
    fill: "white"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2995 35.6001H21.4995V36.4001H22.2995V35.6001Z",
    fill: "white"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 35.6001H22.2993V36.4001H23.0993V35.6001Z",
    fill: "white"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 35.6001V36.4001H23.4996C23.6057 36.4001 23.7074 36.358 23.7824 36.2829C23.8575 36.2079 23.8996 36.1062 23.8996 36.0001C23.8996 35.894 23.8575 35.7923 23.7824 35.7173C23.7074 35.6422 23.6057 35.6001 23.4996 35.6001",
    fill: "white"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0996 36.4001H27.8996V36.0001C27.8996 35.894 27.8575 35.7923 27.7824 35.7173C27.7074 35.6422 27.6057 35.6001 27.4996 35.6001C27.3935 35.6001 27.2918 35.6422 27.2168 35.7173C27.1417 35.7923 27.0996 35.894 27.0996 36.0001",
    fill: "white"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 35.6001H28.6997V36.4001H29.4997V35.6001Z",
    fill: "white"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0993 35.6001H30.2993V36.4001H31.0993V35.6001Z",
    fill: "white"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 36.4001V35.6001H32.2999C32.1938 35.6001 32.0921 35.6422 32.0171 35.7173C31.942 35.7923 31.8999 35.894 31.8999 36.0001C31.8999 36.1062 31.942 36.2079 32.0171 36.2829C32.0921 36.358 32.1938 36.4001 32.2999 36.4001",
    fill: "white"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6997 35.6001V36.4001H33.4997V36.0001C33.4997 35.894 33.4576 35.7923 33.3825 35.7173C33.3075 35.6422 33.2058 35.6001 33.0997 35.6001",
    fill: "white"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 35.6001H34.2993V36.4001H35.0993V35.6001Z",
    fill: "white"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8996 35.6001H35.0996V36.4001H35.4996C35.6057 36.4001 35.7074 36.358 35.7825 36.2829C35.8575 36.2079 35.8996 36.1062 35.8996 36.0001",
    fill: "white"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6997 36.4001H37.4997V35.6001H37.0997C36.9936 35.6001 36.8919 35.6422 36.8169 35.7173C36.7418 35.7923 36.6997 35.894 36.6997 36.0001",
    fill: "white"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 35.6001H37.4995V36.4001H38.2995V35.6001Z",
    fill: "white"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0993 35.6001H38.2993V36.4001H39.0993V35.6001Z",
    fill: "white"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8996 36.3999H11.0996V36.7999C11.0996 36.906 11.1418 37.0077 11.2168 37.0827C11.2918 37.1578 11.3935 37.1999 11.4996 37.1999C11.6057 37.1999 11.7074 37.1578 11.7825 37.0827C11.8575 37.0077 11.8996 36.906 11.8996 36.7999",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 37.2004H14.2995V36.4004H13.8995C13.7934 36.4004 13.6917 36.4425 13.6167 36.5176C13.5417 36.5926 13.4995 36.6943 13.4995 36.8004",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2993 36.3999V37.1999H14.6993C14.8054 37.1999 14.9071 37.1578 14.9822 37.0827C15.0572 37.0077 15.0993 36.906 15.0993 36.7999C15.0993 36.6938 15.0572 36.5921 14.9822 36.5171C14.9071 36.442 14.8054 36.3999 14.6993 36.3999",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6999 37.2004V36.4004H15.8999V36.8004C15.8999 36.9065 15.942 37.0082 16.0171 37.0832C16.0921 37.1583 16.1938 37.2004 16.2999 37.2004",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 36.3999H16.6997V37.1999H17.4997V36.3999Z",
    fill: "white"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 36.3999H17.4995V37.1999H18.2995V36.3999Z",
    fill: "white"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0993 36.3999H18.2993V37.1999H19.0993V36.3999Z",
    fill: "white"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 36.3999H19.0996V37.1999H19.8996V36.3999Z",
    fill: "white"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6994 36.3999H19.8994V37.1999H20.6994V36.3999Z",
    fill: "white"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 36.3999H20.6997V37.1999H21.0997C21.2058 37.1999 21.3075 37.1578 21.3825 37.0827C21.4576 37.0077 21.4997 36.906 21.4997 36.7999",
    fill: "white"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0993 36.3999H22.2993V37.1999H23.0993V36.3999Z",
    fill: "white"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2994 37.1999C24.5203 37.1999 24.6994 37.0208 24.6994 36.7999C24.6994 36.579 24.5203 36.3999 24.2994 36.3999C24.0785 36.3999 23.8994 36.579 23.8994 36.7999C23.8994 37.0208 24.0785 37.1999 24.2994 37.1999Z",
    fill: "white"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8995 37.1999C26.1204 37.1999 26.2995 37.0208 26.2995 36.7999C26.2995 36.579 26.1204 36.3999 25.8995 36.3999C25.6786 36.3999 25.4995 36.579 25.4995 36.7999C25.4995 37.0208 25.6786 37.1999 25.8995 37.1999Z",
    fill: "white"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 36.3999H27.0996V37.1999H27.8996V36.3999Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6994 36.3999H27.8994V37.1999H28.6994V36.3999Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 36.3999H28.6997V37.1999H29.4997V36.3999Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 36.3999H29.4995V37.1999H30.2995V36.3999Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 36.3999H30.2998V37.1999H30.6998C30.8059 37.1999 30.9076 37.1578 30.9826 37.0827C31.0577 37.0077 31.0998 36.906 31.0998 36.7999",
    fill: "white"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 36.3999H32.6997V37.1999H33.4997V36.3999Z",
    fill: "white"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 36.3999H33.4995V37.1999H34.2995V36.3999Z",
    fill: "white"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 36.3999H34.2993V37.1999H35.0993V36.3999Z",
    fill: "white"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4997 37.2004V36.4004H36.6997V36.8004C36.6997 36.9065 36.7419 37.0082 36.8169 37.0832C36.8919 37.1583 36.9936 37.2004 37.0997 37.2004",
    fill: "white"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2995 36.3999H37.4995V37.1999H38.2995V36.3999Z",
    fill: "white"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0998 36.3999H38.2998V37.1999H38.6998C38.8059 37.1999 38.9076 37.1578 38.9826 37.0827C39.0577 37.0077 39.0998 36.906 39.0998 36.7999",
    fill: "white"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2995 37.2002H13.4995V37.6002C13.4995 37.7063 13.5417 37.808 13.6167 37.883C13.6917 37.9581 13.7934 38.0002 13.8995 38.0002C14.0056 38.0002 14.1073 37.9581 14.1824 37.883C14.2574 37.808 14.2995 37.7063 14.2995 37.6002",
    fill: "white"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 38.0002C15.7205 38.0002 15.8996 37.8211 15.8996 37.6002C15.8996 37.3793 15.7205 37.2002 15.4996 37.2002C15.2787 37.2002 15.0996 37.3793 15.0996 37.6002C15.0996 37.8211 15.2787 38.0002 15.4996 38.0002Z",
    fill: "white"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4997 38.0002V37.2002H16.6997V37.6002C16.6997 37.7063 16.7418 37.808 16.8169 37.883C16.8919 37.9581 16.9936 38.0002 17.0997 38.0002",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2995 37.2002H17.4995V38.0002H17.8995C18.0056 38.0002 18.1073 37.9581 18.1824 37.883C18.2574 37.808 18.2995 37.7063 18.2995 37.6002",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8996 38.0002V37.2002H19.0996V37.6002C19.0996 37.7063 19.1418 37.808 19.2168 37.883C19.2918 37.9581 19.3935 38.0002 19.4996 38.0002",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6999 37.2002H19.8999V38.0002H20.2999C20.406 38.0002 20.5077 37.9581 20.5827 37.883C20.6578 37.808 20.6999 37.7063 20.6999 37.6002",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0998 38.0002V37.2002H22.2998V37.6002C22.2998 37.7063 22.3419 37.808 22.417 37.883C22.492 37.9581 22.5937 38.0002 22.6998 38.0002",
    fill: "white"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0996 37.2002V38.0002H23.4996C23.6057 38.0002 23.7074 37.9581 23.7824 37.883C23.8575 37.808 23.8996 37.7063 23.8996 37.6002C23.8996 37.4941 23.8575 37.3924 23.7824 37.3174C23.7074 37.2423 23.6057 37.2002 23.4996 37.2002",
    fill: "white"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0998 38.0002V37.2002H26.6998C26.5937 37.2002 26.492 37.2423 26.417 37.3174C26.3419 37.3924 26.2998 37.4941 26.2998 37.6002C26.2998 37.7063 26.3419 37.808 26.417 37.883C26.492 37.9581 26.5937 38.0002 26.6998 38.0002",
    fill: "white"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8996 37.2002H27.0996V38.0002H27.4996C27.6057 38.0002 27.7074 37.9581 27.7825 37.883C27.8575 37.808 27.8996 37.7063 27.8996 37.6002",
    fill: "white"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4997 38.0002V37.2002H28.6997V37.6002C28.6997 37.7063 28.7418 37.808 28.8169 37.883C28.8919 37.9581 28.9936 38.0002 29.0997 38.0002",
    fill: "white"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2995 37.2002H29.4995V38.0002H29.8995C30.0056 38.0002 30.1073 37.9581 30.1824 37.883C30.2574 37.808 30.2995 37.7063 30.2995 37.6002",
    fill: "white"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6999 38.0002V37.2002H32.2999C32.1938 37.2002 32.0921 37.2423 32.0171 37.3174C31.942 37.3924 31.8999 37.4941 31.8999 37.6002C31.8999 37.7063 31.942 37.808 32.0171 37.883C32.0921 37.9581 32.1938 38.0002 32.2999 38.0002",
    fill: "white"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4997 37.2002H32.6997V38.0002H33.4997V37.2002Z",
    fill: "white"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2995 37.2002H33.4995V38.0002H34.2995V37.2002Z",
    fill: "white"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0993 37.2002H34.2993V38.0002H35.0993V37.2002Z",
    fill: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 37.2002V38.0002H35.4996C35.6057 38.0002 35.7074 37.9581 35.7824 37.883C35.8575 37.808 35.8996 37.7063 35.8996 37.6002C35.8996 37.4941 35.8575 37.3924 35.7824 37.3174C35.7074 37.2423 35.6057 37.2002 35.4996 37.2002",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2630_28353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0996 0H1.09961V40H41.0996V0Z",
    fill: "#333333"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2630_28353",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2630_28353",
    transform: "scale(0.0144928)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2630_28353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(0.799805)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2630_28353",
    width: 69,
    height: 69,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAABFCAYAAAAcjSspAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIuSURBVHgB7ZqBUQIxEEW/jgXYgWsFWgIdaAfYgVoB14FYAZRgB4wdSAVcB2IFmAzHwEgSwiaXO/C/mR0g4ZLw2exdkgUIIYQQQgg5ZS5QDmnMxZexJf4hlbGVxwQ94hJkD4rigKI4uEJero09Yh0jbprP102dIJ0XYw/NexuYa2Ofxj7QQ8TYxNg3/ME0ZBLZz9Rz/cLYCD3CeoZWjFyi7Ioj6Jgh0sTILUrnwgjSPaQNUazNkEDK3WeCbRDtGwOsg3JR7hHvBdabFgh7lcR1i3FEW7v9FmWM8JweYN+LKqSLsoscaHPVjKMYMxz/AyvFNTGE/iDVFNLGFF8ssavdGmWpAnV3UKAVRTzlXSz/s/eZ21POgtwLwhpnAFfJDrSr5NpT/oNuqD3lqvFoRblFv8g6Hk4fBxTFAUVxQFEcUBQHFMUBRXGgfU4RT/kS3SwKxVNedDy+/YtJ4JoK7eynaMfjhdPHAUVxkFsUwRmgFaX2lJ/F5pNWFF9EF5TnPlCn2jrQijL3lFtPGaEsb4G6Ggq0zyl2137oqauw9ph5870NN0hHsPVG+/qMsKcUTdGwHrHKaBLXbfRZctJ5ckpMeUe/eUUHWG9ZoJ+eUqFDBHmEkcj+phFtTdEDBMfN9TZFKZ5+cYgnhA/e2xLFplyMkfEZqa00dHubtDFHdspsVuOj5/v2iKLGYQZ/2twc6J9sCnuFdE8pAlfJDiiKg9wZ1yE2GdKEEEIIIYQQUppf2ax6+KyTGoEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModernMinimalQr);
export default __webpack_public_path__ + "static/media/modern-minimal-qr.f9b7ec3c3b034d648fc27e778dbf10e3.svg";
export { ForwardRef as ReactComponent };